webpackJsonp([202923723943889,60335399758886],{

/***/ 167:
/***/ (function(module, exports) {

	module.exports = {"data":{"site":{"pathPrefix":"/nearx","siteMetadata":{"title":"NearX","description":"Location Intelligence Platform","image":"http://getwalk.in","url":"https://nearx.getwalk.in","type":"article","siteName":"NearX by Walkin","githubUrl":""}},"allMarkdownRemark":{"edges":[{"node":{"fileAbsolutePath":"/opt/build/repo/docs/groups.md","headings":[{"value":"Groups","depth":1},{"value":"Introduction","depth":2},{"value":"How it works","depth":2},{"value":"Categories","depth":2},{"value":"Groups","depth":2},{"value":"Verify events","depth":2},{"value":"Report inaccurate groups","depth":2},{"value":"Support","depth":2}]}},{"node":{"fileAbsolutePath":"/opt/build/repo/docs/geofences.md","headings":[{"value":"Geofences","depth":1},{"value":"Introduction","depth":2},{"value":"How it works","depth":2},{"value":"Create geofences","depth":2},{"value":"Dwell time detection","depth":2},{"value":"Support","depth":2}]}},{"node":{"fileAbsolutePath":"/opt/build/repo/docs/integrations.md","headings":[{"value":"SDK Integrations","depth":1},{"value":"Introduction","depth":2},{"value":"Android SDK/ARR Integration","depth":2},{"value":"SDK","depth":3},{"value":"ARR","depth":3},{"value":"iOS SDK Integration","depth":2},{"value":"Support","depth":2}]}},{"node":{"fileAbsolutePath":"/opt/build/repo/docs/sample.md","headings":[{"value":"Sample Applications","depth":1},{"value":"Introduction","depth":2},{"value":"Instructions","depth":2},{"value":"Android Prerequisites","depth":3},{"value":"A quick video walkthrough of Console","depth":2},{"value":"Support","depth":2}]}},{"node":{"fileAbsolutePath":"/opt/build/repo/docs/overview.md","headings":[{"value":"Overview","depth":1},{"value":"Introduction","depth":2},{"value":"Glossary","depth":2},{"value":"Quickstart","depth":2},{"value":"Integration made easy","depth":2},{"value":"Developer tools","depth":2},{"value":"Sample Applications","depth":2},{"value":"Support","depth":2}]}},{"node":{"fileAbsolutePath":"/opt/build/repo/docs/sdk.md","headings":[{"value":"SDK","depth":1},{"value":"Introduction","depth":2},{"value":"Accuracy and reliability","depth":2},{"value":"Authentication","depth":2},{"value":"Integrations","depth":2},{"value":"Support","depth":2}]}},{"node":{"fileAbsolutePath":"/opt/build/repo/docs/api.md","headings":[{"value":"API","depth":1},{"value":"INTRODUCTION","depth":3},{"value":"AUTHENTICATION","depth":3},{"value":"ERRORS","depth":3},{"value":"DESCRIPTION","depth":3},{"value":"GEOFENCE","depth":4},{"value":"GROUP","depth":4},{"value":"PLACE","depth":4},{"value":"ENDPOINTS","depth":2},{"value":"LIST GEOFENCES","depth":3},{"value":"QUERY PARAMS","depth":4},{"value":"GET GEOFENCE","depth":3},{"value":"QUERY PARAMS","depth":4},{"value":"CREATE GEOFENCE","depth":3},{"value":"QUERY PARAMS","depth":4},{"value":"UPDATE GEOFENCE","depth":3},{"value":"QUERY PARAMS","depth":4},{"value":"DISABLE GEOFENCE","depth":3},{"value":"QUERY PARAMS","depth":4},{"value":"GET GROUP","depth":3},{"value":"QUERY PARAMS","depth":4},{"value":"LIST GROUP","depth":3},{"value":"QUERY PARAMS","depth":4},{"value":"CREATE GROUP","depth":3},{"value":"QUERY PARAMS","depth":4},{"value":"UPDATE GROUP","depth":3},{"value":"QUERY PARAMS","depth":4},{"value":"DISABLE GROUP","depth":3},{"value":"QUERY PARAMS","depth":4},{"value":"LIST PLACES","depth":3},{"value":"QUERY PARAMS","depth":4},{"value":"GET PLACE","depth":3},{"value":"QUERY PARAMS","depth":4},{"value":"CREATE OR UPDATE PLACE","depth":3},{"value":"QUERY PARAMS","depth":4},{"value":"Support","depth":2}]}}]},"menu":{"pages":[{"dir":"./src","file":"pages/landing.js","title":"Home","url":"/","layout":"walkin_default","relativePath":"src/pages/landing.js","absolutePath":"/opt/build/repo/docs-www/src/pages/landing.js","sidemenu":[]},{"dir":"../docs","title":"Documentation","url":"/docs/overview","layout":"walkin_default","sidemenu":[{"title":"Overview","file":"overview.md","relativePath":"../docs/overview.md","absolutePath":"/opt/build/repo/docs/overview.md","items":[],"url":"/docs/overview"},{"title":"Geofences","file":"geofences.md","relativePath":"../docs/geofences.md","absolutePath":"/opt/build/repo/docs/geofences.md","items":[],"url":"/docs/geofences"},{"title":"Groups","file":"groups.md","relativePath":"../docs/groups.md","absolutePath":"/opt/build/repo/docs/groups.md","items":[],"url":"/docs/groups"},{"title":"SDK","file":"sdk.md","relativePath":"../docs/sdk.md","absolutePath":"/opt/build/repo/docs/sdk.md","items":[],"url":"/docs/sdk"},{"title":"API","file":"api.md","relativePath":"../docs/api.md","absolutePath":"/opt/build/repo/docs/api.md","items":[],"url":"/docs/api"},{"title":"SDK Integrations","file":"integrations.md","relativePath":"../docs/integrations.md","absolutePath":"/opt/build/repo/docs/integrations.md","items":[],"url":"/docs/integrations"},{"title":"Sample Apps","file":"sample.md","relativePath":"../docs/sample.md","absolutePath":"/opt/build/repo/docs/sample.md","items":[],"url":"/docs/sample"}],"relativePath":null,"absolutePath":null},{"dir":"./src","title":"Pricing","url":"/pricing","file":"pages/pricing.js","layout":"walkin_default","relativePath":"src/pages/pricing.js","absolutePath":"/opt/build/repo/docs-www/src/pages/pricing.js","sidemenu":[]},{"dir":"./src","title":"Sign Up","url":"/signup","file":"pages/signup.js","layout":"walkin_default","relativePath":"src/pages/signup.js","absolutePath":"/opt/build/repo/docs-www/src/pages/signup.js","sidemenu":[]},{"dir":"./src","title":"Contact Us","url":"/sales","file":"pages/sales.js","layout":"walkin_default","relativePath":"src/pages/sales.js","absolutePath":"/opt/build/repo/docs-www/src/pages/sales.js","sidemenu":[]}]}},"layoutContext":{}}

/***/ }),

/***/ 295:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _walkin_default = __webpack_require__(310);
	
	var _walkin_default2 = _interopRequireDefault(_walkin_default);
	
	var _layoutWalkinDefault = __webpack_require__(167);
	
	var _layoutWalkinDefault2 = _interopRequireDefault(_layoutWalkinDefault);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(_walkin_default2.default, _extends({}, props, _layoutWalkinDefault2.default));
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ 300:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var GithubIcon = function GithubIcon() {
	  return _react2.default.createElement(
	    "svg",
	    { height: "32", viewBox: "0 0 16 16", version: "1.1", width: "32", fill: "#fff" },
	    _react2.default.createElement("path", { fillRule: "evenodd", d: "M8 0C3.58 0 0 3.58 0 8c0 3.54 2.29 6.53 5.47 7.59.4.07.55-.17.55-.38 0-.19-.01-.82-.01-1.49-2.01.37-2.53-.49-2.69-.94-.09-.23-.48-.94-.82-1.13-.28-.15-.68-.52-.01-.53.63-.01 1.08.58 1.23.82.72 1.21 1.87.87 2.33.66.07-.52.28-.87.51-1.07-1.78-.2-3.64-.89-3.64-3.95 0-.87.31-1.59.82-2.15-.08-.2-.36-1.02.08-2.12 0 0 .67-.21 2.2.82.64-.18 1.32-.27 2-.27.68 0 1.36.09 2 .27 1.53-1.04 2.2-.82 2.2-.82.44 1.1.16 1.92.08 2.12.51.56.82 1.27.82 2.15 0 3.07-1.87 3.75-3.65 3.95.29.25.54.73.54 1.48 0 1.07-.01 1.93-.01 2.2 0 .21.15.46.55.38A8.013 8.013 0 0 0 16 8c0-4.42-3.58-8-8-8z" })
	  );
	};
	
	exports.default = GithubIcon;
	module.exports = exports["default"];

/***/ }),

/***/ 301:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mainModule = __webpack_require__(579);
	
	var _mainModule2 = _interopRequireDefault(_mainModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Main = function Main(_ref) {
	  var children = _ref.children;
	  return _react2.default.createElement(
	    'main',
	    { className: _mainModule2.default.main },
	    children()
	  );
	};
	
	exports.default = Main;
	module.exports = exports['default'];

/***/ }),

/***/ 579:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"main":"node_modules--brainhubeu-gatsby-docs-kit-src-components-main----main-module---main---25yzl"};

/***/ }),

/***/ 302:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(684);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _propTypes = __webpack_require__(10);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SEO = function (_React$Component) {
	  _inherits(SEO, _React$Component);
	
	  function SEO() {
	    _classCallCheck(this, SEO);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  SEO.prototype.render = function render() {
	    var siteMetadata = this.props.siteMetadata;
	
	    return _react2.default.createElement(
	      _reactHelmet2.default,
	      null,
	      _react2.default.createElement(
	        'title',
	        null,
	        siteMetadata.title
	      ),
	      siteMetadata.description && _react2.default.createElement('meta', { name: 'description', content: siteMetadata.description }),
	      siteMetadata.image && _react2.default.createElement('meta', { name: 'image', content: siteMetadata.image }),
	      siteMetadata.siteName && _react2.default.createElement('meta', { property: 'og:site_name', content: siteMetadata.siteName }),
	      siteMetadata.url && _react2.default.createElement('meta', { property: 'og:url', content: siteMetadata.url }),
	      siteMetadata.type && _react2.default.createElement('meta', { property: 'og:type', content: siteMetadata.type }),
	      siteMetadata.title && _react2.default.createElement('meta', { property: 'og:title', content: siteMetadata.title }),
	      siteMetadata.description && _react2.default.createElement('meta', { property: 'og:description', content: siteMetadata.description }),
	      siteMetadata.image && _react2.default.createElement('meta', { property: 'og:image', content: siteMetadata.image })
	    );
	  };
	
	  return SEO;
	}(_react2.default.Component);
	
	SEO.propTypes = {
	  siteMetadata: _propTypes2.default.shape({
	    description: _propTypes2.default.string,
	    image: _propTypes2.default.string,
	    url: _propTypes2.default.string,
	    type: _propTypes2.default.string,
	    title: _propTypes2.default.string,
	    siteName: _propTypes2.default.string
	  })
	};
	exports.default = SEO;
	module.exports = exports['default'];

/***/ }),

/***/ 673:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 674:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 205:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _propTypes = __webpack_require__(10);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var menuPropTypes = {
	  title: _propTypes2.default.string,
	  file: _propTypes2.default.string,
	  relativePath: _propTypes2.default.string,
	  absolutePath: _propTypes2.default.string,
	  url: _propTypes2.default.string,
	  hash: _propTypes2.default.string
	};
	
	exports.default = _propTypes2.default.arrayOf(_propTypes2.default.shape({
	  title: _propTypes2.default.string,
	  dir: _propTypes2.default.string,
	  file: _propTypes2.default.string,
	  relativePath: _propTypes2.default.string,
	  absolutePath: _propTypes2.default.string,
	  template: _propTypes2.default.string,
	  layout: _propTypes2.default.string,
	  href: _propTypes2.default.string,
	  url: _propTypes2.default.string,
	  sidemenu: _propTypes2.default.arrayOf(_propTypes2.default.shape(_extends({}, menuPropTypes, {
	    items: _propTypes2.default.arrayOf(_propTypes2.default.shape(_extends({}, menuPropTypes, {
	      items: _propTypes2.default.arrayOf(_propTypes2.default.shape(menuPropTypes))
	    })))
	  })))
	}));
	module.exports = exports['default'];

/***/ }),

/***/ 304:
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.findMatchingPage = findMatchingPage;
	
	/**
	 * Retrieve all url's from menu
	 * @param {Array} menuItems
	 * @return {Array} urls
	 */
	function getAllUrls(menuItems) {
	  if (!menuItems) {
	    return [];
	  }
	
	  return menuItems.reduce(function (acc, menuItem) {
	    acc.push(menuItem.url);
	
	    if (menuItem.items) {
	      acc.push.apply(acc, getAllUrls(menuItem.items));
	    }
	
	    return acc;
	  }, []);
	}
	
	/**
	 * Find page, that matches location pathname
	 * @param {Array} menuItems
	 * @param {String} pathname location pathname
	 * @param {String} prefix
	 * @return {Object} page config
	 */
	function findMatchingPage(menuItems, pathname) {
	  var prefix = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
	
	  if (!menuItems) {
	    return false;
	  }
	
	  if (!pathname.startsWith(prefix)) {
	    return false;
	  }
	
	  var pathNameWithoutPrefix = pathname.substr(prefix.length);
	
	  return menuItems.find(function (menuItem) {
	    if (!menuItem) {
	      return false;
	    }
	
	    return pathNameWithoutPrefix === menuItem.url || getAllUrls(menuItem.sidemenu || menuItem.items).indexOf(pathNameWithoutPrefix) !== -1;
	  });
	}

/***/ }),

/***/ 305:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	var GithubSlugger = __webpack_require__(646);
	
	var addItemToMenu = function addItemToMenu(sidemenu, file, url, hash, title, depth, currentDepth) {
	  currentDepth = currentDepth || 2; // h1 are excluded
	
	  if (depth === currentDepth) {
	    sidemenu.push({ file: file, url: '' + url + hash, title: title, items: [] });
	  } else {
	    currentDepth++;
	    var last = sidemenu.pop();
	    if (last) {
	      addItemToMenu(last.items, file, url, hash, title, depth, currentDepth);
	      sidemenu.push(last);
	    }
	  }
	};
	
	var createSideMenu = function createSideMenu(activeData, data) {
	  var slugger = new GithubSlugger();
	  activeData.depthOfMenu = (activeData.depthOfMenu || 6) + 1; // menu starts from h2
	  var sidemenu = [];
	
	  var matchedMarkdownEdge = data.allMarkdownRemark.edges.find(function (edge) {
	    return edge.node.fileAbsolutePath === activeData.absolutePath;
	  });
	
	  if (!matchedMarkdownEdge) {
	    return [];
	  }
	
	  matchedMarkdownEdge.node.headings.filter(function (child) {
	    return child.depth >= 2 && child.depth <= activeData.depthOfMenu;
	  }).map(function (child) {
	    return {
	      hash: '#' + slugger.slug(child.value),
	      depth: child.depth,
	      value: child.value
	    };
	  }).map(function (child) {
	    return addItemToMenu(sidemenu, activeData.file, activeData.url, child.hash, child.value, child.depth);
	  });
	  return sidemenu;
	};
	
	exports.default = createSideMenu;
	
	/**
	 * Determines whether page has sidemenu
	 * @param {Object} page
	 * @return {Boolean}
	 */
	
	var hasSideMenu = exports.hasSideMenu = function hasSideMenu(page) {
	  return !!page && !!page.sidemenu && !!page.sidemenu.length;
	};

/***/ }),

/***/ 45:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  Copyright (c) 2017 Jed Watson.
	  Licensed under the MIT License (MIT), see
	  http://jedwatson.github.io/classnames
	*/
	/* global define */
	
	(function () {
		'use strict';
	
		var hasOwn = {}.hasOwnProperty;
	
		function classNames () {
			var classes = [];
	
			for (var i = 0; i < arguments.length; i++) {
				var arg = arguments[i];
				if (!arg) continue;
	
				var argType = typeof arg;
	
				if (argType === 'string' || argType === 'number') {
					classes.push(arg);
				} else if (Array.isArray(arg) && arg.length) {
					var inner = classNames.apply(null, arg);
					if (inner) {
						classes.push(inner);
					}
				} else if (argType === 'object') {
					for (var key in arg) {
						if (hasOwn.call(arg, key) && arg[key]) {
							classes.push(key);
						}
					}
				}
			}
	
			return classes.join(' ');
		}
	
		if (typeof module !== 'undefined' && module.exports) {
			classNames.default = classNames;
			module.exports = classNames;
		} else if (true) {
			// register as 'classnames', consistent with npm package name
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return classNames;
			}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			window.classNames = classNames;
		}
	}());


/***/ }),

/***/ 563:
/***/ (function(module, exports, __webpack_require__) {

	var pSlice = Array.prototype.slice;
	var objectKeys = __webpack_require__(565);
	var isArguments = __webpack_require__(564);
	
	var deepEqual = module.exports = function (actual, expected, opts) {
	  if (!opts) opts = {};
	  // 7.1. All identical values are equivalent, as determined by ===.
	  if (actual === expected) {
	    return true;
	
	  } else if (actual instanceof Date && expected instanceof Date) {
	    return actual.getTime() === expected.getTime();
	
	  // 7.3. Other pairs that do not both pass typeof value == 'object',
	  // equivalence is determined by ==.
	  } else if (!actual || !expected || typeof actual != 'object' && typeof expected != 'object') {
	    return opts.strict ? actual === expected : actual == expected;
	
	  // 7.4. For all other Object pairs, including Array objects, equivalence is
	  // determined by having the same number of owned properties (as verified
	  // with Object.prototype.hasOwnProperty.call), the same set of keys
	  // (although not necessarily the same order), equivalent values for every
	  // corresponding key, and an identical 'prototype' property. Note: this
	  // accounts for both named and indexed properties on Arrays.
	  } else {
	    return objEquiv(actual, expected, opts);
	  }
	}
	
	function isUndefinedOrNull(value) {
	  return value === null || value === undefined;
	}
	
	function isBuffer (x) {
	  if (!x || typeof x !== 'object' || typeof x.length !== 'number') return false;
	  if (typeof x.copy !== 'function' || typeof x.slice !== 'function') {
	    return false;
	  }
	  if (x.length > 0 && typeof x[0] !== 'number') return false;
	  return true;
	}
	
	function objEquiv(a, b, opts) {
	  var i, key;
	  if (isUndefinedOrNull(a) || isUndefinedOrNull(b))
	    return false;
	  // an identical 'prototype' property.
	  if (a.prototype !== b.prototype) return false;
	  //~~~I've managed to break Object.keys through screwy arguments passing.
	  //   Converting to array solves the problem.
	  if (isArguments(a)) {
	    if (!isArguments(b)) {
	      return false;
	    }
	    a = pSlice.call(a);
	    b = pSlice.call(b);
	    return deepEqual(a, b, opts);
	  }
	  if (isBuffer(a)) {
	    if (!isBuffer(b)) {
	      return false;
	    }
	    if (a.length !== b.length) return false;
	    for (i = 0; i < a.length; i++) {
	      if (a[i] !== b[i]) return false;
	    }
	    return true;
	  }
	  try {
	    var ka = objectKeys(a),
	        kb = objectKeys(b);
	  } catch (e) {//happens when one is a string literal and the other isn't
	    return false;
	  }
	  // having the same number of owned properties (keys incorporates
	  // hasOwnProperty)
	  if (ka.length != kb.length)
	    return false;
	  //the same set of keys (although not necessarily the same order),
	  ka.sort();
	  kb.sort();
	  //~~~cheap key test
	  for (i = ka.length - 1; i >= 0; i--) {
	    if (ka[i] != kb[i])
	      return false;
	  }
	  //equivalent values for every corresponding key, and
	  //~~~possibly expensive deep test
	  for (i = ka.length - 1; i >= 0; i--) {
	    key = ka[i];
	    if (!deepEqual(a[key], b[key], opts)) return false;
	  }
	  return typeof a === typeof b;
	}


/***/ }),

/***/ 564:
/***/ (function(module, exports) {

	var supportsArgumentsClass = (function(){
	  return Object.prototype.toString.call(arguments)
	})() == '[object Arguments]';
	
	exports = module.exports = supportsArgumentsClass ? supported : unsupported;
	
	exports.supported = supported;
	function supported(object) {
	  return Object.prototype.toString.call(object) == '[object Arguments]';
	};
	
	exports.unsupported = unsupported;
	function unsupported(object){
	  return object &&
	    typeof object == 'object' &&
	    typeof object.length == 'number' &&
	    Object.prototype.hasOwnProperty.call(object, 'callee') &&
	    !Object.prototype.propertyIsEnumerable.call(object, 'callee') ||
	    false;
	};


/***/ }),

/***/ 565:
/***/ (function(module, exports) {

	exports = module.exports = typeof Object.keys === 'function'
	  ? Object.keys : shim;
	
	exports.shim = shim;
	function shim (obj) {
	  var keys = [];
	  for (var key in obj) keys.push(key);
	  return keys;
	}


/***/ }),

/***/ 573:
/***/ (function(module, exports) {

	module.exports = function() {
		return /[\xA9\xAE\u203C\u2049\u2122\u2139\u2194-\u2199\u21A9\u21AA\u231A\u231B\u2328\u23CF\u23E9-\u23F3\u23F8-\u23FA\u24C2\u25AA\u25AB\u25B6\u25C0\u25FB-\u25FE\u2600-\u2604\u260E\u2611\u2614\u2615\u2618\u261D\u2620\u2622\u2623\u2626\u262A\u262E\u262F\u2638-\u263A\u2648-\u2653\u2660\u2663\u2665\u2666\u2668\u267B\u267F\u2692-\u2694\u2696\u2697\u2699\u269B\u269C\u26A0\u26A1\u26AA\u26AB\u26B0\u26B1\u26BD\u26BE\u26C4\u26C5\u26C8\u26CE\u26CF\u26D1\u26D3\u26D4\u26E9\u26EA\u26F0-\u26F5\u26F7-\u26FA\u26FD\u2702\u2705\u2708-\u270D\u270F\u2712\u2714\u2716\u271D\u2721\u2728\u2733\u2734\u2744\u2747\u274C\u274E\u2753-\u2755\u2757\u2763\u2764\u2795-\u2797\u27A1\u27B0\u27BF\u2934\u2935\u2B05-\u2B07\u2B1B\u2B1C\u2B50\u2B55\u3030\u303D\u3297\u3299]|\uD83C[\uDC04\uDCCF\uDD70\uDD71\uDD7E\uDD7F\uDD8E\uDD91-\uDD9A\uDE01\uDE02\uDE1A\uDE2F\uDE32-\uDE3A\uDE50\uDE51\uDF00-\uDF21\uDF24-\uDF93\uDF96\uDF97\uDF99-\uDF9B\uDF9E-\uDFF0\uDFF3-\uDFF5\uDFF7-\uDFFF]|\uD83D[\uDC00-\uDCFD\uDCFF-\uDD3D\uDD49-\uDD4E\uDD50-\uDD67\uDD6F\uDD70\uDD73-\uDD79\uDD87\uDD8A-\uDD8D\uDD90\uDD95\uDD96\uDDA5\uDDA8\uDDB1\uDDB2\uDDBC\uDDC2-\uDDC4\uDDD1-\uDDD3\uDDDC-\uDDDE\uDDE1\uDDE3\uDDEF\uDDF3\uDDFA-\uDE4F\uDE80-\uDEC5\uDECB-\uDED0\uDEE0-\uDEE5\uDEE9\uDEEB\uDEEC\uDEF0\uDEF3]|\uD83E[\uDD10-\uDD18\uDD80-\uDD84\uDDC0]|\uD83C\uDDFF\uD83C[\uDDE6\uDDF2\uDDFC]|\uD83C\uDDFE\uD83C[\uDDEA\uDDF9]|\uD83C\uDDFD\uD83C\uDDF0|\uD83C\uDDFC\uD83C[\uDDEB\uDDF8]|\uD83C\uDDFB\uD83C[\uDDE6\uDDE8\uDDEA\uDDEC\uDDEE\uDDF3\uDDFA]|\uD83C\uDDFA\uD83C[\uDDE6\uDDEC\uDDF2\uDDF8\uDDFE\uDDFF]|\uD83C\uDDF9\uD83C[\uDDE6\uDDE8\uDDE9\uDDEB-\uDDED\uDDEF-\uDDF4\uDDF7\uDDF9\uDDFB\uDDFC\uDDFF]|\uD83C\uDDF8\uD83C[\uDDE6-\uDDEA\uDDEC-\uDDF4\uDDF7-\uDDF9\uDDFB\uDDFD-\uDDFF]|\uD83C\uDDF7\uD83C[\uDDEA\uDDF4\uDDF8\uDDFA\uDDFC]|\uD83C\uDDF6\uD83C\uDDE6|\uD83C\uDDF5\uD83C[\uDDE6\uDDEA-\uDDED\uDDF0-\uDDF3\uDDF7-\uDDF9\uDDFC\uDDFE]|\uD83C\uDDF4\uD83C\uDDF2|\uD83C\uDDF3\uD83C[\uDDE6\uDDE8\uDDEA-\uDDEC\uDDEE\uDDF1\uDDF4\uDDF5\uDDF7\uDDFA\uDDFF]|\uD83C\uDDF2\uD83C[\uDDE6\uDDE8-\uDDED\uDDF0-\uDDFF]|\uD83C\uDDF1\uD83C[\uDDE6-\uDDE8\uDDEE\uDDF0\uDDF7-\uDDFB\uDDFE]|\uD83C\uDDF0\uD83C[\uDDEA\uDDEC-\uDDEE\uDDF2\uDDF3\uDDF5\uDDF7\uDDFC\uDDFE\uDDFF]|\uD83C\uDDEF\uD83C[\uDDEA\uDDF2\uDDF4\uDDF5]|\uD83C\uDDEE\uD83C[\uDDE8-\uDDEA\uDDF1-\uDDF4\uDDF6-\uDDF9]|\uD83C\uDDED\uD83C[\uDDF0\uDDF2\uDDF3\uDDF7\uDDF9\uDDFA]|\uD83C\uDDEC\uD83C[\uDDE6\uDDE7\uDDE9-\uDDEE\uDDF1-\uDDF3\uDDF5-\uDDFA\uDDFC\uDDFE]|\uD83C\uDDEB\uD83C[\uDDEE-\uDDF0\uDDF2\uDDF4\uDDF7]|\uD83C\uDDEA\uD83C[\uDDE6\uDDE8\uDDEA\uDDEC\uDDED\uDDF7-\uDDFA]|\uD83C\uDDE9\uD83C[\uDDEA\uDDEC\uDDEF\uDDF0\uDDF2\uDDF4\uDDFF]|\uD83C\uDDE8\uD83C[\uDDE6\uDDE8\uDDE9\uDDEB-\uDDEE\uDDF0-\uDDF5\uDDF7\uDDFA-\uDDFF]|\uD83C\uDDE7\uD83C[\uDDE6\uDDE7\uDDE9-\uDDEF\uDDF1-\uDDF4\uDDF6-\uDDF9\uDDFB\uDDFC\uDDFE\uDDFF]|\uD83C\uDDE6\uD83C[\uDDE8-\uDDEC\uDDEE\uDDF1\uDDF2\uDDF4\uDDF6-\uDDFA\uDDFC\uDDFD\uDDFF]|[#\*0-9]\u20E3/g;
	};


/***/ }),

/***/ 578:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  Copyright (c) 2015 Jed Watson.
	  Based on code that is Copyright 2013-2015, Facebook, Inc.
	  All rights reserved.
	*/
	/* global define */
	
	(function () {
		'use strict';
	
		var canUseDOM = !!(
			typeof window !== 'undefined' &&
			window.document &&
			window.document.createElement
		);
	
		var ExecutionEnvironment = {
	
			canUseDOM: canUseDOM,
	
			canUseWorkers: typeof Worker !== 'undefined',
	
			canUseEventListeners:
				canUseDOM && !!(window.addEventListener || window.attachEvent),
	
			canUseViewport: canUseDOM && !!window.screen
	
		};
	
		if (true) {
			!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return ExecutionEnvironment;
			}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else if (typeof module !== 'undefined' && module.exports) {
			module.exports = ExecutionEnvironment;
		} else {
			window.ExecutionEnvironment = ExecutionEnvironment;
		}
	
	}());


/***/ }),

/***/ 646:
/***/ (function(module, exports, __webpack_require__) {

	var emoji = __webpack_require__(573)
	
	module.exports = BananaSlug
	
	function BananaSlug () {
	  var self = this
	  if (!(self instanceof BananaSlug)) return new BananaSlug()
	
	  self.reset()
	}
	
	/**
	 * Generate a unique slug.
	 * @param  {string} value String of text to slugify
	 * @param  {boolean} [false] Keep the current case, otherwise make all lowercase
	 * @return {string}       A unique slug string
	 */
	BananaSlug.prototype.slug = function (value, maintainCase) {
	  maintainCase = maintainCase === true
	  var self = this
	  var slug = slugger(value, maintainCase)
	  var occurrences = self.occurrences[slug]
	
	  if (self.occurrences.hasOwnProperty(slug)) {
	    occurrences++
	  } else {
	    occurrences = 0
	  }
	
	  self.occurrences[slug] = occurrences
	
	  if (occurrences) {
	    slug = slug + '-' + occurrences
	  }
	
	  return slug
	}
	
	/**
	 * Reset - Forget all previous slugs
	 * @return void
	 */
	BananaSlug.prototype.reset = function () {
	  this.occurrences = {}
	}
	
	var whitespace = /\s/g
	
	function lower (string) {
	  return string.toLowerCase()
	}
	
	function slugger (string, maintainCase) {
	  var re = /[\u2000-\u206F\u2E00-\u2E7F\\'!"#$%&()*+,./:;<=>?@[\]^`{|}~]/g
	  var replacement = '-'
	
	  if (typeof string !== 'string') return ''
	  if (!maintainCase) string = string.replace(/[A-Z]+/g, lower)
	  return string.trim()
	    .replace(re, '')
	    .replace(emoji(), '')
	    .replace(whitespace, replacement)
	}


/***/ }),

/***/ 684:
/***/ (function(module, exports, __webpack_require__) {

	exports.__esModule = true;
	exports.Helmet = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(10);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSideEffect = __webpack_require__(687);
	
	var _reactSideEffect2 = _interopRequireDefault(_reactSideEffect);
	
	var _deepEqual = __webpack_require__(563);
	
	var _deepEqual2 = _interopRequireDefault(_deepEqual);
	
	var _HelmetUtils = __webpack_require__(685);
	
	var _HelmetConstants = __webpack_require__(272);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Helmet = function Helmet(Component) {
	    var _class, _temp;
	
	    return _temp = _class = function (_React$Component) {
	        _inherits(HelmetWrapper, _React$Component);
	
	        function HelmetWrapper() {
	            _classCallCheck(this, HelmetWrapper);
	
	            return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	        }
	
	        HelmetWrapper.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	            return !(0, _deepEqual2.default)(this.props, nextProps);
	        };
	
	        HelmetWrapper.prototype.mapNestedChildrenToProps = function mapNestedChildrenToProps(child, nestedChildren) {
	            if (!nestedChildren) {
	                return null;
	            }
	
	            switch (child.type) {
	                case _HelmetConstants.TAG_NAMES.SCRIPT:
	                case _HelmetConstants.TAG_NAMES.NOSCRIPT:
	                    return {
	                        innerHTML: nestedChildren
	                    };
	
	                case _HelmetConstants.TAG_NAMES.STYLE:
	                    return {
	                        cssText: nestedChildren
	                    };
	            }
	
	            throw new Error("<" + child.type + " /> elements are self-closing and can not contain children. Refer to our API for more information.");
	        };
	
	        HelmetWrapper.prototype.flattenArrayTypeChildren = function flattenArrayTypeChildren(_ref) {
	            var _extends2;
	
	            var child = _ref.child,
	                arrayTypeChildren = _ref.arrayTypeChildren,
	                newChildProps = _ref.newChildProps,
	                nestedChildren = _ref.nestedChildren;
	
	            return _extends({}, arrayTypeChildren, (_extends2 = {}, _extends2[child.type] = [].concat(arrayTypeChildren[child.type] || [], [_extends({}, newChildProps, this.mapNestedChildrenToProps(child, nestedChildren))]), _extends2));
	        };
	
	        HelmetWrapper.prototype.mapObjectTypeChildren = function mapObjectTypeChildren(_ref2) {
	            var _extends3, _extends4;
	
	            var child = _ref2.child,
	                newProps = _ref2.newProps,
	                newChildProps = _ref2.newChildProps,
	                nestedChildren = _ref2.nestedChildren;
	
	            switch (child.type) {
	                case _HelmetConstants.TAG_NAMES.TITLE:
	                    return _extends({}, newProps, (_extends3 = {}, _extends3[child.type] = nestedChildren, _extends3.titleAttributes = _extends({}, newChildProps), _extends3));
	
	                case _HelmetConstants.TAG_NAMES.BODY:
	                    return _extends({}, newProps, {
	                        bodyAttributes: _extends({}, newChildProps)
	                    });
	
	                case _HelmetConstants.TAG_NAMES.HTML:
	                    return _extends({}, newProps, {
	                        htmlAttributes: _extends({}, newChildProps)
	                    });
	            }
	
	            return _extends({}, newProps, (_extends4 = {}, _extends4[child.type] = _extends({}, newChildProps), _extends4));
	        };
	
	        HelmetWrapper.prototype.mapArrayTypeChildrenToProps = function mapArrayTypeChildrenToProps(arrayTypeChildren, newProps) {
	            var newFlattenedProps = _extends({}, newProps);
	
	            Object.keys(arrayTypeChildren).forEach(function (arrayChildName) {
	                var _extends5;
	
	                newFlattenedProps = _extends({}, newFlattenedProps, (_extends5 = {}, _extends5[arrayChildName] = arrayTypeChildren[arrayChildName], _extends5));
	            });
	
	            return newFlattenedProps;
	        };
	
	        HelmetWrapper.prototype.warnOnInvalidChildren = function warnOnInvalidChildren(child, nestedChildren) {
	            if (false) {
	                if (!_HelmetConstants.VALID_TAG_NAMES.some(function (name) {
	                    return child.type === name;
	                })) {
	                    if (typeof child.type === "function") {
	                        return (0, _HelmetUtils.warn)("You may be attempting to nest <Helmet> components within each other, which is not allowed. Refer to our API for more information.");
	                    }
	
	                    return (0, _HelmetUtils.warn)("Only elements types " + _HelmetConstants.VALID_TAG_NAMES.join(", ") + " are allowed. Helmet does not support rendering <" + child.type + "> elements. Refer to our API for more information.");
	                }
	
	                if (nestedChildren && typeof nestedChildren !== "string" && (!Array.isArray(nestedChildren) || nestedChildren.some(function (nestedChild) {
	                    return typeof nestedChild !== "string";
	                }))) {
	                    throw new Error("Helmet expects a string as a child of <" + child.type + ">. Did you forget to wrap your children in braces? ( <" + child.type + ">{``}</" + child.type + "> ) Refer to our API for more information.");
	                }
	            }
	
	            return true;
	        };
	
	        HelmetWrapper.prototype.mapChildrenToProps = function mapChildrenToProps(children, newProps) {
	            var _this2 = this;
	
	            var arrayTypeChildren = {};
	
	            _react2.default.Children.forEach(children, function (child) {
	                if (!child || !child.props) {
	                    return;
	                }
	
	                var _child$props = child.props,
	                    nestedChildren = _child$props.children,
	                    childProps = _objectWithoutProperties(_child$props, ["children"]);
	
	                var newChildProps = (0, _HelmetUtils.convertReactPropstoHtmlAttributes)(childProps);
	
	                _this2.warnOnInvalidChildren(child, nestedChildren);
	
	                switch (child.type) {
	                    case _HelmetConstants.TAG_NAMES.LINK:
	                    case _HelmetConstants.TAG_NAMES.META:
	                    case _HelmetConstants.TAG_NAMES.NOSCRIPT:
	                    case _HelmetConstants.TAG_NAMES.SCRIPT:
	                    case _HelmetConstants.TAG_NAMES.STYLE:
	                        arrayTypeChildren = _this2.flattenArrayTypeChildren({
	                            child: child,
	                            arrayTypeChildren: arrayTypeChildren,
	                            newChildProps: newChildProps,
	                            nestedChildren: nestedChildren
	                        });
	                        break;
	
	                    default:
	                        newProps = _this2.mapObjectTypeChildren({
	                            child: child,
	                            newProps: newProps,
	                            newChildProps: newChildProps,
	                            nestedChildren: nestedChildren
	                        });
	                        break;
	                }
	            });
	
	            newProps = this.mapArrayTypeChildrenToProps(arrayTypeChildren, newProps);
	            return newProps;
	        };
	
	        HelmetWrapper.prototype.render = function render() {
	            var _props = this.props,
	                children = _props.children,
	                props = _objectWithoutProperties(_props, ["children"]);
	
	            var newProps = _extends({}, props);
	
	            if (children) {
	                newProps = this.mapChildrenToProps(children, newProps);
	            }
	
	            return _react2.default.createElement(Component, newProps);
	        };
	
	        _createClass(HelmetWrapper, null, [{
	            key: "canUseDOM",
	
	
	            // Component.peek comes from react-side-effect:
	            // For testing, you may use a static peek() method available on the returned component.
	            // It lets you get the current state without resetting the mounted instance stack.
	            // Don’t use it for anything other than testing.
	
	            /**
	            * @param {Object} base: {"target": "_blank", "href": "http://mysite.com/"}
	            * @param {Object} bodyAttributes: {"className": "root"}
	            * @param {String} defaultTitle: "Default Title"
	            * @param {Boolean} defer: true
	            * @param {Boolean} encodeSpecialCharacters: true
	            * @param {Object} htmlAttributes: {"lang": "en", "amp": undefined}
	            * @param {Array} link: [{"rel": "canonical", "href": "http://mysite.com/example"}]
	            * @param {Array} meta: [{"name": "description", "content": "Test description"}]
	            * @param {Array} noscript: [{"innerHTML": "<img src='http://mysite.com/js/test.js'"}]
	            * @param {Function} onChangeClientState: "(newState) => console.log(newState)"
	            * @param {Array} script: [{"type": "text/javascript", "src": "http://mysite.com/js/test.js"}]
	            * @param {Array} style: [{"type": "text/css", "cssText": "div { display: block; color: blue; }"}]
	            * @param {String} title: "Title"
	            * @param {Object} titleAttributes: {"itemprop": "name"}
	            * @param {String} titleTemplate: "MySite.com - %s"
	            */
	            set: function set(canUseDOM) {
	                Component.canUseDOM = canUseDOM;
	            }
	        }]);
	
	        return HelmetWrapper;
	    }(_react2.default.Component), _class.propTypes = {
	        base: _propTypes2.default.object,
	        bodyAttributes: _propTypes2.default.object,
	        children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node]),
	        defaultTitle: _propTypes2.default.string,
	        defer: _propTypes2.default.bool,
	        encodeSpecialCharacters: _propTypes2.default.bool,
	        htmlAttributes: _propTypes2.default.object,
	        link: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        meta: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        noscript: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        onChangeClientState: _propTypes2.default.func,
	        script: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        style: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        title: _propTypes2.default.string,
	        titleAttributes: _propTypes2.default.object,
	        titleTemplate: _propTypes2.default.string
	    }, _class.defaultProps = {
	        defer: true,
	        encodeSpecialCharacters: true
	    }, _class.peek = Component.peek, _class.rewind = function () {
	        var mappedState = Component.rewind();
	        if (!mappedState) {
	            // provide fallback if mappedState is undefined
	            mappedState = (0, _HelmetUtils.mapStateOnServer)({
	                baseTag: [],
	                bodyAttributes: {},
	                encodeSpecialCharacters: true,
	                htmlAttributes: {},
	                linkTags: [],
	                metaTags: [],
	                noscriptTags: [],
	                scriptTags: [],
	                styleTags: [],
	                title: "",
	                titleAttributes: {}
	            });
	        }
	
	        return mappedState;
	    }, _temp;
	};
	
	var NullComponent = function NullComponent() {
	    return null;
	};
	
	var HelmetSideEffects = (0, _reactSideEffect2.default)(_HelmetUtils.reducePropsToState, _HelmetUtils.handleClientStateChange, _HelmetUtils.mapStateOnServer)(NullComponent);
	
	var HelmetExport = Helmet(HelmetSideEffects);
	HelmetExport.renderStatic = HelmetExport.rewind;
	
	exports.Helmet = HelmetExport;
	exports.default = HelmetExport;

/***/ }),

/***/ 272:
/***/ (function(module, exports) {

	exports.__esModule = true;
	var ATTRIBUTE_NAMES = exports.ATTRIBUTE_NAMES = {
	    BODY: "bodyAttributes",
	    HTML: "htmlAttributes",
	    TITLE: "titleAttributes"
	};
	
	var TAG_NAMES = exports.TAG_NAMES = {
	    BASE: "base",
	    BODY: "body",
	    HEAD: "head",
	    HTML: "html",
	    LINK: "link",
	    META: "meta",
	    NOSCRIPT: "noscript",
	    SCRIPT: "script",
	    STYLE: "style",
	    TITLE: "title"
	};
	
	var VALID_TAG_NAMES = exports.VALID_TAG_NAMES = Object.keys(TAG_NAMES).map(function (name) {
	    return TAG_NAMES[name];
	});
	
	var TAG_PROPERTIES = exports.TAG_PROPERTIES = {
	    CHARSET: "charset",
	    CSS_TEXT: "cssText",
	    HREF: "href",
	    HTTPEQUIV: "http-equiv",
	    INNER_HTML: "innerHTML",
	    ITEM_PROP: "itemprop",
	    NAME: "name",
	    PROPERTY: "property",
	    REL: "rel",
	    SRC: "src"
	};
	
	var REACT_TAG_MAP = exports.REACT_TAG_MAP = {
	    accesskey: "accessKey",
	    charset: "charSet",
	    class: "className",
	    contenteditable: "contentEditable",
	    contextmenu: "contextMenu",
	    "http-equiv": "httpEquiv",
	    itemprop: "itemProp",
	    tabindex: "tabIndex"
	};
	
	var HELMET_PROPS = exports.HELMET_PROPS = {
	    DEFAULT_TITLE: "defaultTitle",
	    DEFER: "defer",
	    ENCODE_SPECIAL_CHARACTERS: "encodeSpecialCharacters",
	    ON_CHANGE_CLIENT_STATE: "onChangeClientState",
	    TITLE_TEMPLATE: "titleTemplate"
	};
	
	var HTML_TAG_MAP = exports.HTML_TAG_MAP = Object.keys(REACT_TAG_MAP).reduce(function (obj, key) {
	    obj[REACT_TAG_MAP[key]] = key;
	    return obj;
	}, {});
	
	var SELF_CLOSING_TAGS = exports.SELF_CLOSING_TAGS = [TAG_NAMES.NOSCRIPT, TAG_NAMES.SCRIPT, TAG_NAMES.STYLE];
	
	var HELMET_ATTRIBUTE = exports.HELMET_ATTRIBUTE = "data-react-helmet";

/***/ }),

/***/ 685:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {exports.__esModule = true;
	exports.warn = exports.requestAnimationFrame = exports.reducePropsToState = exports.mapStateOnServer = exports.handleClientStateChange = exports.convertReactPropstoHtmlAttributes = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _objectAssign = __webpack_require__(168);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	var _HelmetConstants = __webpack_require__(272);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var encodeSpecialCharacters = function encodeSpecialCharacters(str) {
	    var encode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	
	    if (encode === false) {
	        return String(str);
	    }
	
	    return String(str).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#x27;");
	};
	
	var getTitleFromPropsList = function getTitleFromPropsList(propsList) {
	    var innermostTitle = getInnermostProperty(propsList, _HelmetConstants.TAG_NAMES.TITLE);
	    var innermostTemplate = getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.TITLE_TEMPLATE);
	
	    if (innermostTemplate && innermostTitle) {
	        // use function arg to avoid need to escape $ characters
	        return innermostTemplate.replace(/%s/g, function () {
	            return innermostTitle;
	        });
	    }
	
	    var innermostDefaultTitle = getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.DEFAULT_TITLE);
	
	    return innermostTitle || innermostDefaultTitle || undefined;
	};
	
	var getOnChangeClientState = function getOnChangeClientState(propsList) {
	    return getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.ON_CHANGE_CLIENT_STATE) || function () {};
	};
	
	var getAttributesFromPropsList = function getAttributesFromPropsList(tagType, propsList) {
	    return propsList.filter(function (props) {
	        return typeof props[tagType] !== "undefined";
	    }).map(function (props) {
	        return props[tagType];
	    }).reduce(function (tagAttrs, current) {
	        return _extends({}, tagAttrs, current);
	    }, {});
	};
	
	var getBaseTagFromPropsList = function getBaseTagFromPropsList(primaryAttributes, propsList) {
	    return propsList.filter(function (props) {
	        return typeof props[_HelmetConstants.TAG_NAMES.BASE] !== "undefined";
	    }).map(function (props) {
	        return props[_HelmetConstants.TAG_NAMES.BASE];
	    }).reverse().reduce(function (innermostBaseTag, tag) {
	        if (!innermostBaseTag.length) {
	            var keys = Object.keys(tag);
	
	            for (var i = 0; i < keys.length; i++) {
	                var attributeKey = keys[i];
	                var lowerCaseAttributeKey = attributeKey.toLowerCase();
	
	                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && tag[lowerCaseAttributeKey]) {
	                    return innermostBaseTag.concat(tag);
	                }
	            }
	        }
	
	        return innermostBaseTag;
	    }, []);
	};
	
	var getTagsFromPropsList = function getTagsFromPropsList(tagName, primaryAttributes, propsList) {
	    // Calculate list of tags, giving priority innermost component (end of the propslist)
	    var approvedSeenTags = {};
	
	    return propsList.filter(function (props) {
	        if (Array.isArray(props[tagName])) {
	            return true;
	        }
	        if (typeof props[tagName] !== "undefined") {
	            warn("Helmet: " + tagName + " should be of type \"Array\". Instead found type \"" + _typeof(props[tagName]) + "\"");
	        }
	        return false;
	    }).map(function (props) {
	        return props[tagName];
	    }).reverse().reduce(function (approvedTags, instanceTags) {
	        var instanceSeenTags = {};
	
	        instanceTags.filter(function (tag) {
	            var primaryAttributeKey = void 0;
	            var keys = Object.keys(tag);
	            for (var i = 0; i < keys.length; i++) {
	                var attributeKey = keys[i];
	                var lowerCaseAttributeKey = attributeKey.toLowerCase();
	
	                // Special rule with link tags, since rel and href are both primary tags, rel takes priority
	                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && !(primaryAttributeKey === _HelmetConstants.TAG_PROPERTIES.REL && tag[primaryAttributeKey].toLowerCase() === "canonical") && !(lowerCaseAttributeKey === _HelmetConstants.TAG_PROPERTIES.REL && tag[lowerCaseAttributeKey].toLowerCase() === "stylesheet")) {
	                    primaryAttributeKey = lowerCaseAttributeKey;
	                }
	                // Special case for innerHTML which doesn't work lowercased
	                if (primaryAttributes.indexOf(attributeKey) !== -1 && (attributeKey === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || attributeKey === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT || attributeKey === _HelmetConstants.TAG_PROPERTIES.ITEM_PROP)) {
	                    primaryAttributeKey = attributeKey;
	                }
	            }
	
	            if (!primaryAttributeKey || !tag[primaryAttributeKey]) {
	                return false;
	            }
	
	            var value = tag[primaryAttributeKey].toLowerCase();
	
	            if (!approvedSeenTags[primaryAttributeKey]) {
	                approvedSeenTags[primaryAttributeKey] = {};
	            }
	
	            if (!instanceSeenTags[primaryAttributeKey]) {
	                instanceSeenTags[primaryAttributeKey] = {};
	            }
	
	            if (!approvedSeenTags[primaryAttributeKey][value]) {
	                instanceSeenTags[primaryAttributeKey][value] = true;
	                return true;
	            }
	
	            return false;
	        }).reverse().forEach(function (tag) {
	            return approvedTags.push(tag);
	        });
	
	        // Update seen tags with tags from this instance
	        var keys = Object.keys(instanceSeenTags);
	        for (var i = 0; i < keys.length; i++) {
	            var attributeKey = keys[i];
	            var tagUnion = (0, _objectAssign2.default)({}, approvedSeenTags[attributeKey], instanceSeenTags[attributeKey]);
	
	            approvedSeenTags[attributeKey] = tagUnion;
	        }
	
	        return approvedTags;
	    }, []).reverse();
	};
	
	var getInnermostProperty = function getInnermostProperty(propsList, property) {
	    for (var i = propsList.length - 1; i >= 0; i--) {
	        var props = propsList[i];
	
	        if (props.hasOwnProperty(property)) {
	            return props[property];
	        }
	    }
	
	    return null;
	};
	
	var reducePropsToState = function reducePropsToState(propsList) {
	    return {
	        baseTag: getBaseTagFromPropsList([_HelmetConstants.TAG_PROPERTIES.HREF], propsList),
	        bodyAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.BODY, propsList),
	        defer: getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.DEFER),
	        encode: getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.ENCODE_SPECIAL_CHARACTERS),
	        htmlAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.HTML, propsList),
	        linkTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.LINK, [_HelmetConstants.TAG_PROPERTIES.REL, _HelmetConstants.TAG_PROPERTIES.HREF], propsList),
	        metaTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.META, [_HelmetConstants.TAG_PROPERTIES.NAME, _HelmetConstants.TAG_PROPERTIES.CHARSET, _HelmetConstants.TAG_PROPERTIES.HTTPEQUIV, _HelmetConstants.TAG_PROPERTIES.PROPERTY, _HelmetConstants.TAG_PROPERTIES.ITEM_PROP], propsList),
	        noscriptTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.NOSCRIPT, [_HelmetConstants.TAG_PROPERTIES.INNER_HTML], propsList),
	        onChangeClientState: getOnChangeClientState(propsList),
	        scriptTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.SCRIPT, [_HelmetConstants.TAG_PROPERTIES.SRC, _HelmetConstants.TAG_PROPERTIES.INNER_HTML], propsList),
	        styleTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.STYLE, [_HelmetConstants.TAG_PROPERTIES.CSS_TEXT], propsList),
	        title: getTitleFromPropsList(propsList),
	        titleAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.TITLE, propsList)
	    };
	};
	
	var rafPolyfill = function () {
	    var clock = Date.now();
	
	    return function (callback) {
	        var currentTime = Date.now();
	
	        if (currentTime - clock > 16) {
	            clock = currentTime;
	            callback(currentTime);
	        } else {
	            setTimeout(function () {
	                rafPolyfill(callback);
	            }, 0);
	        }
	    };
	}();
	
	var cafPolyfill = function cafPolyfill(id) {
	    return clearTimeout(id);
	};
	
	var requestAnimationFrame = typeof window !== "undefined" ? window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || rafPolyfill : global.requestAnimationFrame || rafPolyfill;
	
	var cancelAnimationFrame = typeof window !== "undefined" ? window.cancelAnimationFrame || window.webkitCancelAnimationFrame || window.mozCancelAnimationFrame || cafPolyfill : global.cancelAnimationFrame || cafPolyfill;
	
	var warn = function warn(msg) {
	    return console && typeof console.warn === "function" && console.warn(msg);
	};
	
	var _helmetCallback = null;
	
	var handleClientStateChange = function handleClientStateChange(newState) {
	    if (_helmetCallback) {
	        cancelAnimationFrame(_helmetCallback);
	    }
	
	    if (newState.defer) {
	        _helmetCallback = requestAnimationFrame(function () {
	            commitTagChanges(newState, function () {
	                _helmetCallback = null;
	            });
	        });
	    } else {
	        commitTagChanges(newState);
	        _helmetCallback = null;
	    }
	};
	
	var commitTagChanges = function commitTagChanges(newState, cb) {
	    var baseTag = newState.baseTag,
	        bodyAttributes = newState.bodyAttributes,
	        htmlAttributes = newState.htmlAttributes,
	        linkTags = newState.linkTags,
	        metaTags = newState.metaTags,
	        noscriptTags = newState.noscriptTags,
	        onChangeClientState = newState.onChangeClientState,
	        scriptTags = newState.scriptTags,
	        styleTags = newState.styleTags,
	        title = newState.title,
	        titleAttributes = newState.titleAttributes;
	
	    updateAttributes(_HelmetConstants.TAG_NAMES.BODY, bodyAttributes);
	    updateAttributes(_HelmetConstants.TAG_NAMES.HTML, htmlAttributes);
	
	    updateTitle(title, titleAttributes);
	
	    var tagUpdates = {
	        baseTag: updateTags(_HelmetConstants.TAG_NAMES.BASE, baseTag),
	        linkTags: updateTags(_HelmetConstants.TAG_NAMES.LINK, linkTags),
	        metaTags: updateTags(_HelmetConstants.TAG_NAMES.META, metaTags),
	        noscriptTags: updateTags(_HelmetConstants.TAG_NAMES.NOSCRIPT, noscriptTags),
	        scriptTags: updateTags(_HelmetConstants.TAG_NAMES.SCRIPT, scriptTags),
	        styleTags: updateTags(_HelmetConstants.TAG_NAMES.STYLE, styleTags)
	    };
	
	    var addedTags = {};
	    var removedTags = {};
	
	    Object.keys(tagUpdates).forEach(function (tagType) {
	        var _tagUpdates$tagType = tagUpdates[tagType],
	            newTags = _tagUpdates$tagType.newTags,
	            oldTags = _tagUpdates$tagType.oldTags;
	
	
	        if (newTags.length) {
	            addedTags[tagType] = newTags;
	        }
	        if (oldTags.length) {
	            removedTags[tagType] = tagUpdates[tagType].oldTags;
	        }
	    });
	
	    cb && cb();
	
	    onChangeClientState(newState, addedTags, removedTags);
	};
	
	var flattenArray = function flattenArray(possibleArray) {
	    return Array.isArray(possibleArray) ? possibleArray.join("") : possibleArray;
	};
	
	var updateTitle = function updateTitle(title, attributes) {
	    if (typeof title !== "undefined" && document.title !== title) {
	        document.title = flattenArray(title);
	    }
	
	    updateAttributes(_HelmetConstants.TAG_NAMES.TITLE, attributes);
	};
	
	var updateAttributes = function updateAttributes(tagName, attributes) {
	    var elementTag = document.getElementsByTagName(tagName)[0];
	
	    if (!elementTag) {
	        return;
	    }
	
	    var helmetAttributeString = elementTag.getAttribute(_HelmetConstants.HELMET_ATTRIBUTE);
	    var helmetAttributes = helmetAttributeString ? helmetAttributeString.split(",") : [];
	    var attributesToRemove = [].concat(helmetAttributes);
	    var attributeKeys = Object.keys(attributes);
	
	    for (var i = 0; i < attributeKeys.length; i++) {
	        var attribute = attributeKeys[i];
	        var value = attributes[attribute] || "";
	
	        if (elementTag.getAttribute(attribute) !== value) {
	            elementTag.setAttribute(attribute, value);
	        }
	
	        if (helmetAttributes.indexOf(attribute) === -1) {
	            helmetAttributes.push(attribute);
	        }
	
	        var indexToSave = attributesToRemove.indexOf(attribute);
	        if (indexToSave !== -1) {
	            attributesToRemove.splice(indexToSave, 1);
	        }
	    }
	
	    for (var _i = attributesToRemove.length - 1; _i >= 0; _i--) {
	        elementTag.removeAttribute(attributesToRemove[_i]);
	    }
	
	    if (helmetAttributes.length === attributesToRemove.length) {
	        elementTag.removeAttribute(_HelmetConstants.HELMET_ATTRIBUTE);
	    } else if (elementTag.getAttribute(_HelmetConstants.HELMET_ATTRIBUTE) !== attributeKeys.join(",")) {
	        elementTag.setAttribute(_HelmetConstants.HELMET_ATTRIBUTE, attributeKeys.join(","));
	    }
	};
	
	var updateTags = function updateTags(type, tags) {
	    var headElement = document.head || document.querySelector(_HelmetConstants.TAG_NAMES.HEAD);
	    var tagNodes = headElement.querySelectorAll(type + "[" + _HelmetConstants.HELMET_ATTRIBUTE + "]");
	    var oldTags = Array.prototype.slice.call(tagNodes);
	    var newTags = [];
	    var indexToDelete = void 0;
	
	    if (tags && tags.length) {
	        tags.forEach(function (tag) {
	            var newElement = document.createElement(type);
	
	            for (var attribute in tag) {
	                if (tag.hasOwnProperty(attribute)) {
	                    if (attribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML) {
	                        newElement.innerHTML = tag.innerHTML;
	                    } else if (attribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT) {
	                        if (newElement.styleSheet) {
	                            newElement.styleSheet.cssText = tag.cssText;
	                        } else {
	                            newElement.appendChild(document.createTextNode(tag.cssText));
	                        }
	                    } else {
	                        var value = typeof tag[attribute] === "undefined" ? "" : tag[attribute];
	                        newElement.setAttribute(attribute, value);
	                    }
	                }
	            }
	
	            newElement.setAttribute(_HelmetConstants.HELMET_ATTRIBUTE, "true");
	
	            // Remove a duplicate tag from domTagstoRemove, so it isn't cleared.
	            if (oldTags.some(function (existingTag, index) {
	                indexToDelete = index;
	                return newElement.isEqualNode(existingTag);
	            })) {
	                oldTags.splice(indexToDelete, 1);
	            } else {
	                newTags.push(newElement);
	            }
	        });
	    }
	
	    oldTags.forEach(function (tag) {
	        return tag.parentNode.removeChild(tag);
	    });
	    newTags.forEach(function (tag) {
	        return headElement.appendChild(tag);
	    });
	
	    return {
	        oldTags: oldTags,
	        newTags: newTags
	    };
	};
	
	var generateElementAttributesAsString = function generateElementAttributesAsString(attributes) {
	    return Object.keys(attributes).reduce(function (str, key) {
	        var attr = typeof attributes[key] !== "undefined" ? key + "=\"" + attributes[key] + "\"" : "" + key;
	        return str ? str + " " + attr : attr;
	    }, "");
	};
	
	var generateTitleAsString = function generateTitleAsString(type, title, attributes, encode) {
	    var attributeString = generateElementAttributesAsString(attributes);
	    var flattenedTitle = flattenArray(title);
	    return attributeString ? "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\" " + attributeString + ">" + encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">" : "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\">" + encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">";
	};
	
	var generateTagsAsString = function generateTagsAsString(type, tags, encode) {
	    return tags.reduce(function (str, tag) {
	        var attributeHtml = Object.keys(tag).filter(function (attribute) {
	            return !(attribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || attribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT);
	        }).reduce(function (string, attribute) {
	            var attr = typeof tag[attribute] === "undefined" ? attribute : attribute + "=\"" + encodeSpecialCharacters(tag[attribute], encode) + "\"";
	            return string ? string + " " + attr : attr;
	        }, "");
	
	        var tagContent = tag.innerHTML || tag.cssText || "";
	
	        var isSelfClosing = _HelmetConstants.SELF_CLOSING_TAGS.indexOf(type) === -1;
	
	        return str + "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\" " + attributeHtml + (isSelfClosing ? "/>" : ">" + tagContent + "</" + type + ">");
	    }, "");
	};
	
	var convertElementAttributestoReactProps = function convertElementAttributestoReactProps(attributes) {
	    var initProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    return Object.keys(attributes).reduce(function (obj, key) {
	        obj[_HelmetConstants.REACT_TAG_MAP[key] || key] = attributes[key];
	        return obj;
	    }, initProps);
	};
	
	var convertReactPropstoHtmlAttributes = function convertReactPropstoHtmlAttributes(props) {
	    var initAttributes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    return Object.keys(props).reduce(function (obj, key) {
	        obj[_HelmetConstants.HTML_TAG_MAP[key] || key] = props[key];
	        return obj;
	    }, initAttributes);
	};
	
	var generateTitleAsReactComponent = function generateTitleAsReactComponent(type, title, attributes) {
	    var _initProps;
	
	    // assigning into an array to define toString function on it
	    var initProps = (_initProps = {
	        key: title
	    }, _initProps[_HelmetConstants.HELMET_ATTRIBUTE] = true, _initProps);
	    var props = convertElementAttributestoReactProps(attributes, initProps);
	
	    return [_react2.default.createElement(_HelmetConstants.TAG_NAMES.TITLE, props, title)];
	};
	
	var generateTagsAsReactComponent = function generateTagsAsReactComponent(type, tags) {
	    return tags.map(function (tag, i) {
	        var _mappedTag;
	
	        var mappedTag = (_mappedTag = {
	            key: i
	        }, _mappedTag[_HelmetConstants.HELMET_ATTRIBUTE] = true, _mappedTag);
	
	        Object.keys(tag).forEach(function (attribute) {
	            var mappedAttribute = _HelmetConstants.REACT_TAG_MAP[attribute] || attribute;
	
	            if (mappedAttribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || mappedAttribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT) {
	                var content = tag.innerHTML || tag.cssText;
	                mappedTag.dangerouslySetInnerHTML = { __html: content };
	            } else {
	                mappedTag[mappedAttribute] = tag[attribute];
	            }
	        });
	
	        return _react2.default.createElement(type, mappedTag);
	    });
	};
	
	var getMethodsForTag = function getMethodsForTag(type, tags, encode) {
	    switch (type) {
	        case _HelmetConstants.TAG_NAMES.TITLE:
	            return {
	                toComponent: function toComponent() {
	                    return generateTitleAsReactComponent(type, tags.title, tags.titleAttributes, encode);
	                },
	                toString: function toString() {
	                    return generateTitleAsString(type, tags.title, tags.titleAttributes, encode);
	                }
	            };
	        case _HelmetConstants.ATTRIBUTE_NAMES.BODY:
	        case _HelmetConstants.ATTRIBUTE_NAMES.HTML:
	            return {
	                toComponent: function toComponent() {
	                    return convertElementAttributestoReactProps(tags);
	                },
	                toString: function toString() {
	                    return generateElementAttributesAsString(tags);
	                }
	            };
	        default:
	            return {
	                toComponent: function toComponent() {
	                    return generateTagsAsReactComponent(type, tags);
	                },
	                toString: function toString() {
	                    return generateTagsAsString(type, tags, encode);
	                }
	            };
	    }
	};
	
	var mapStateOnServer = function mapStateOnServer(_ref) {
	    var baseTag = _ref.baseTag,
	        bodyAttributes = _ref.bodyAttributes,
	        encode = _ref.encode,
	        htmlAttributes = _ref.htmlAttributes,
	        linkTags = _ref.linkTags,
	        metaTags = _ref.metaTags,
	        noscriptTags = _ref.noscriptTags,
	        scriptTags = _ref.scriptTags,
	        styleTags = _ref.styleTags,
	        _ref$title = _ref.title,
	        title = _ref$title === undefined ? "" : _ref$title,
	        titleAttributes = _ref.titleAttributes;
	    return {
	        base: getMethodsForTag(_HelmetConstants.TAG_NAMES.BASE, baseTag, encode),
	        bodyAttributes: getMethodsForTag(_HelmetConstants.ATTRIBUTE_NAMES.BODY, bodyAttributes, encode),
	        htmlAttributes: getMethodsForTag(_HelmetConstants.ATTRIBUTE_NAMES.HTML, htmlAttributes, encode),
	        link: getMethodsForTag(_HelmetConstants.TAG_NAMES.LINK, linkTags, encode),
	        meta: getMethodsForTag(_HelmetConstants.TAG_NAMES.META, metaTags, encode),
	        noscript: getMethodsForTag(_HelmetConstants.TAG_NAMES.NOSCRIPT, noscriptTags, encode),
	        script: getMethodsForTag(_HelmetConstants.TAG_NAMES.SCRIPT, scriptTags, encode),
	        style: getMethodsForTag(_HelmetConstants.TAG_NAMES.STYLE, styleTags, encode),
	        title: getMethodsForTag(_HelmetConstants.TAG_NAMES.TITLE, { title: title, titleAttributes: titleAttributes }, encode)
	    };
	};
	
	exports.convertReactPropstoHtmlAttributes = convertReactPropstoHtmlAttributes;
	exports.handleClientStateChange = handleClientStateChange;
	exports.mapStateOnServer = mapStateOnServer;
	exports.reducePropsToState = reducePropsToState;
	exports.requestAnimationFrame = requestAnimationFrame;
	exports.warn = warn;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),

/***/ 687:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var React = __webpack_require__(2);
	var React__default = _interopDefault(React);
	var ExecutionEnvironment = _interopDefault(__webpack_require__(578));
	var shallowEqual = _interopDefault(__webpack_require__(703));
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function withSideEffect(reducePropsToState, handleStateChangeOnClient, mapStateOnServer) {
	  if (typeof reducePropsToState !== 'function') {
	    throw new Error('Expected reducePropsToState to be a function.');
	  }
	  if (typeof handleStateChangeOnClient !== 'function') {
	    throw new Error('Expected handleStateChangeOnClient to be a function.');
	  }
	  if (typeof mapStateOnServer !== 'undefined' && typeof mapStateOnServer !== 'function') {
	    throw new Error('Expected mapStateOnServer to either be undefined or a function.');
	  }
	
	  function getDisplayName(WrappedComponent) {
	    return WrappedComponent.displayName || WrappedComponent.name || 'Component';
	  }
	
	  return function wrap(WrappedComponent) {
	    if (typeof WrappedComponent !== 'function') {
	      throw new Error('Expected WrappedComponent to be a React component.');
	    }
	
	    var mountedInstances = [];
	    var state = void 0;
	
	    function emitChange() {
	      state = reducePropsToState(mountedInstances.map(function (instance) {
	        return instance.props;
	      }));
	
	      if (SideEffect.canUseDOM) {
	        handleStateChangeOnClient(state);
	      } else if (mapStateOnServer) {
	        state = mapStateOnServer(state);
	      }
	    }
	
	    var SideEffect = function (_Component) {
	      _inherits(SideEffect, _Component);
	
	      function SideEffect() {
	        _classCallCheck(this, SideEffect);
	
	        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	      }
	
	      // Try to use displayName of wrapped component
	      SideEffect.peek = function peek() {
	        return state;
	      };
	
	      // Expose canUseDOM so tests can monkeypatch it
	
	
	      SideEffect.rewind = function rewind() {
	        if (SideEffect.canUseDOM) {
	          throw new Error('You may only call rewind() on the server. Call peek() to read the current state.');
	        }
	
	        var recordedState = state;
	        state = undefined;
	        mountedInstances = [];
	        return recordedState;
	      };
	
	      SideEffect.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	        return !shallowEqual(nextProps, this.props);
	      };
	
	      SideEffect.prototype.componentWillMount = function componentWillMount() {
	        mountedInstances.push(this);
	        emitChange();
	      };
	
	      SideEffect.prototype.componentDidUpdate = function componentDidUpdate() {
	        emitChange();
	      };
	
	      SideEffect.prototype.componentWillUnmount = function componentWillUnmount() {
	        var index = mountedInstances.indexOf(this);
	        mountedInstances.splice(index, 1);
	        emitChange();
	      };
	
	      SideEffect.prototype.render = function render() {
	        return React__default.createElement(WrappedComponent, this.props);
	      };
	
	      return SideEffect;
	    }(React.Component);
	
	    SideEffect.displayName = 'SideEffect(' + getDisplayName(WrappedComponent) + ')';
	    SideEffect.canUseDOM = ExecutionEnvironment.canUseDOM;
	
	
	    return SideEffect;
	  };
	}
	
	module.exports = withSideEffect;


/***/ }),

/***/ 703:
/***/ (function(module, exports) {

	module.exports = function shallowEqual(objA, objB, compare, compareContext) {
	
	    var ret = compare ? compare.call(compareContext, objA, objB) : void 0;
	
	    if(ret !== void 0) {
	        return !!ret;
	    }
	
	    if(objA === objB) {
	        return true;
	    }
	
	    if(typeof objA !== 'object' || !objA ||
	       typeof objB !== 'object' || !objB) {
	        return false;
	    }
	
	    var keysA = Object.keys(objA);
	    var keysB = Object.keys(objB);
	
	    if(keysA.length !== keysB.length) {
	        return false;
	    }
	
	    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
	
	    // Test for A's keys different from B.
	    for(var idx = 0; idx < keysA.length; idx++) {
	
	        var key = keysA[idx];
	
	        if(!bHasOwnProperty(key)) {
	            return false;
	        }
	
	        var valueA = objA[key];
	        var valueB = objB[key];
	
	        ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;
	
	        if(ret === false ||
	           ret === void 0 && valueA !== valueB) {
	            return false;
	        }
	
	    }
	
	    return true;
	
	};


/***/ }),

/***/ 306:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _footerModule = __webpack_require__(580);
	
	var _footerModule2 = _interopRequireDefault(_footerModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Footer = function Footer() {
	  return _react2.default.createElement(
	    'footer',
	    { className: _footerModule2.default.footer },
	    _react2.default.createElement(
	      'p',
	      null,
	      '\xA9 2019 ',
	      _react2.default.createElement(
	        'a',
	        { href: 'http://getwalk.in' },
	        'First WalkIn Technologies Pvt Ltd'
	      )
	    )
	  );
	};
	
	exports.default = Footer;
	module.exports = exports['default'];

/***/ }),

/***/ 580:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"whiteColor":"#fff","developerPrimaryColor":"#589e69","professionalPrimaryColor":"#13B9E4","enterprisePrimaryColor":"#eca85a","premiumPrimaryColor":"#FFFFFF59","premiumGradientColor":"transparent linear-gradient(44deg, #5000B7 0%, #21024A 100%) 0% 0% no-repeat padding-box"};

/***/ }),

/***/ 307:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(45);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(10);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _gatsbyLink = __webpack_require__(57);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _menuProptypes = __webpack_require__(205);
	
	var _menuProptypes2 = _interopRequireDefault(_menuProptypes);
	
	var _GithubIcon = __webpack_require__(300);
	
	var _GithubIcon2 = _interopRequireDefault(_GithubIcon);
	
	var _nearx_logo = __webpack_require__(711);
	
	var _nearx_logo2 = _interopRequireDefault(_nearx_logo);
	
	var _headerModule = __webpack_require__(581);
	
	var _headerModule2 = _interopRequireDefault(_headerModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Header = function (_React$Component) {
	  _inherits(Header, _React$Component);
	
	  function Header(props) {
	    _classCallCheck(this, Header);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.componentDidMount = function () {
	      var listChildren = Array.from(_this.listRef.current.children[0].children);
	      _this.listItemWidth = _this.getItemListWidth(listChildren) + 60;
	      // this.listItemWith=150;
	      //console.log("this.listRef.current.clientWidth1 [" + this.listRef.current.clientWidth)
	      //console.log("this.listItemWidth1 [" + this.listItemWidth)
	
	      _this.setState({
	        mobileMenu: _this.listRef.current.clientWidth < _this.listItemWidth
	      });
	
	      window.addEventListener('resize', _this.updateDimensions);
	    };
	
	    _this.updateDimensions = function () {
	      console.log("this.listRef.current.clientWidth2 [" + _this.listRef.current.clientWidth);
	      console.log("this.listItemWidth2 [" + _this.listItemWidth);
	      _this.setState({
	        mobileMenu: _this.listRef.current.clientWidth < _this.listItemWidth
	      });
	    };
	
	    _this.getItemListWidth = function (navArray) {
	      var navWidth = 0;
	
	      navArray.forEach(function (element) {
	        navWidth += element.clientWidth;
	      });
	
	      return navWidth;
	    };
	
	    _this.toggleMenu = function () {
	      _this.setState({ menuIsOpen: !_this.state.menuIsOpen });
	    };
	
	    _this.listRef = _react2.default.createRef();
	    _this.listItemWith = 0;
	
	    _this.state = {
	      mobileMenu: false,
	      mainNavItemsWidth: 0,
	      menuIsOpen: false
	    };
	    return _this;
	  }
	
	  Header.prototype.componentWillUnmount = function componentWillUnmount() {
	    window.removeEventListener('resize', this.updateDimensions);
	  };
	
	  Header.prototype.render = function render() {
	    var _this2 = this;
	
	    var _props = this.props,
	        menuPages = _props.menuPages,
	        activeNavTitle = _props.activeNavTitle,
	        githubUrl = _props.githubUrl;
	
	    console.log("this.state.mobileMenu [" + this.state.mobileMenu);
	    return _react2.default.createElement(
	      'header',
	      {
	        className: (0, _classnames2.default)([_headerModule2.default.header, this.state.mobileMenu && _headerModule2.default['header--mobile']])
	      },
	      _react2.default.createElement(
	        'a',
	        { href: '/' },
	        _react2.default.createElement('img', { src: _nearx_logo2.default, height: '50px', className: _headerModule2.default.header__logo })
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: _headerModule2.default.header__menuWrapper },
	        _react2.default.createElement(
	          'nav',
	          { className: _headerModule2.default.header__nav, ref: this.listRef },
	          _react2.default.createElement(
	            'ul',
	            {
	              className: (0, _classnames2.default)([_headerModule2.default.nav__list, this.state.menuIsOpen && _headerModule2.default['nav__list--mobile__open']])
	
	            },
	            menuPages.map(function (element, index) {
	              console.log("element.url [" + element.url);
	              return _react2.default.createElement(
	                'li',
	                { key: index, className: _headerModule2.default.nav__item },
	                _react2.default.createElement(
	                  _gatsbyLink2.default,
	                  {
	                    to: element.url,
	                    className: (0, _classnames2.default)([_headerModule2.default.nav__link, activeNavTitle === element.title ? _headerModule2.default['nav__link--active'] : null]),
	                    'data-after': element.title,
	                    onClick: _this2.toggleMenu
	                  },
	                  _react2.default.createElement(
	                    'span',
	                    null,
	                    element.title
	                  )
	                )
	              );
	            })
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: _headerModule2.default.menu__btnsWrapper },
	          githubUrl && _react2.default.createElement(
	            'a',
	            { href: githubUrl, target: '_blank', className: _headerModule2.default.header__github },
	            _react2.default.createElement(_GithubIcon2.default, null)
	          ),
	          this.state.mobileMenu && _react2.default.createElement(
	            'button',
	            {
	              className: (0, _classnames2.default)([_headerModule2.default.header__mobileBtn, this.state.menuIsOpen && _headerModule2.default['header__mobileBtn--active']]),
	              onClick: this.toggleMenu
	            },
	            _react2.default.createElement('span', { className: _headerModule2.default.mobileBtn__hamburger })
	          )
	        )
	      )
	    );
	  };
	
	  return Header;
	}(_react2.default.Component);
	
	Header.propTypes = {
	  location: _propTypes2.default.string,
	  activeNavTitle: _propTypes2.default.string,
	  menuPages: _menuProptypes2.default,
	  githubUrl: _propTypes2.default.string
	};
	
	exports.default = Header;
	module.exports = exports['default'];

/***/ }),

/***/ 581:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"whiteColor":"#fff","developerPrimaryColor":"#589e69","professionalPrimaryColor":"#13B9E4","enterprisePrimaryColor":"#eca85a","premiumPrimaryColor":"#FFFFFF59","premiumGradientColor":"transparent linear-gradient(44deg, #5000B7 0%, #21024A 100%) 0% 0% no-repeat padding-box","header":"src-components-header----header-module---header---3QwAt","header--mobile":"src-components-header----header-module---header--mobile---2-RNA","nav__list":"src-components-header----header-module---nav__list---1eCty","nav__list--mobile__open":"src-components-header----header-module---nav__list--mobile__open---qWSzI","fromTop":"src-components-header----header-module---fromTop---1t6xx","nav__item":"src-components-header----header-module---nav__item---14wsO","nav__link":"src-components-header----header-module---nav__link---27-lH","header__logo":"src-components-header----header-module---header__logo---1G9WW","header__menuWrapper":"src-components-header----header-module---header__menuWrapper---IjyDR","header__nav":"src-components-header----header-module---header__nav---XspGw","nav__link--active":"src-components-header----header-module---nav__link--active---kP6J0","menu__btnsWrapper":"src-components-header----header-module---menu__btnsWrapper---H-XUT","header__mobileBtn":"src-components-header----header-module---header__mobileBtn---1tejZ","mobileBtn__hamburger":"src-components-header----header-module---mobileBtn__hamburger---3uB6P","header__mobileBtn--active":"src-components-header----header-module---header__mobileBtn--active---xzUpe","header__github":"src-components-header----header-module---header__github---2D8xy","opacity":"src-components-header----header-module---opacity---lOOg0"};

/***/ }),

/***/ 308:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(57);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _classnames = __webpack_require__(45);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _sideNavModule = __webpack_require__(582);
	
	var _sideNavModule2 = _interopRequireDefault(_sideNavModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var createMenuList = function createMenuList(listData, location) {
	  return _react2.default.createElement(
	    'ul',
	    { className: _sideNavModule2.default.sideNav__sideList },
	    listData.map(function (element) {
	      return _react2.default.createElement(
	        'li',
	        { key: element.title, className: _sideNavModule2.default.sideList__item },
	        element.file && _react2.default.createElement(
	          _gatsbyLink2.default,
	          {
	            to: element.url || element.href,
	            className: (0, _classnames2.default)([_sideNavModule2.default.subNav__link, location === element.url && _sideNavModule2.default['subNav__link--active']])
	          },
	          element.title
	        ),
	        !element.file && _react2.default.createElement(
	          'span',
	          { className: _sideNavModule2.default.subNav__header },
	          element.title
	        ),
	        element.items && createMenuList(element.items, location)
	      );
	    })
	  );
	};
	
	var SideNav = function SideNav(_ref) {
	  var activeNavData = _ref.activeNavData,
	      location = _ref.location;
	  return _react2.default.createElement(
	    'div',
	    { className: _sideNavModule2.default.sideNav__scrollableWrapper },
	    _react2.default.createElement(
	      'nav',
	      { className: _sideNavModule2.default.sideNav },
	      createMenuList(activeNavData.sidemenu, location)
	    )
	  );
	};
	
	exports.default = SideNav;
	module.exports = exports['default'];

/***/ }),

/***/ 582:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"sideNav":"src-components-sideNav----sideNav-module---sideNav---2liBa","sideNav__scrollableWrapper":"src-components-sideNav----sideNav-module---sideNav__scrollableWrapper---YLFsG","sideNav__sideList":"src-components-sideNav----sideNav-module---sideNav__sideList---2Hu18","subNav__header":"src-components-sideNav----sideNav-module---subNav__header---dyaqk","subNav__link":"src-components-sideNav----sideNav-module---subNav__link---1Y03e","subNav__link--active":"src-components-sideNav----sideNav-module---subNav__link--active---1lHwo","sideNav__slideList":"src-components-sideNav----sideNav-module---sideNav__slideList---Op-Ht"};

/***/ }),

/***/ 310:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(10);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _menuProptypes = __webpack_require__(205);
	
	var _menuProptypes2 = _interopRequireDefault(_menuProptypes);
	
	var _navigation = __webpack_require__(304);
	
	var _Header = __webpack_require__(307);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _SideNav = __webpack_require__(308);
	
	var _SideNav2 = _interopRequireDefault(_SideNav);
	
	var _Main = __webpack_require__(301);
	
	var _Main2 = _interopRequireDefault(_Main);
	
	var _Footer = __webpack_require__(306);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _sideMenu = __webpack_require__(305);
	
	var _sideMenu2 = _interopRequireDefault(_sideMenu);
	
	var _seo = __webpack_require__(302);
	
	var _seo2 = _interopRequireDefault(_seo);
	
	__webpack_require__(674);
	
	__webpack_require__(675);
	
	__webpack_require__(673);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var getPathName = function getPathName(location) {
	  var pathNamePrefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
	
	  var pathName = location.pathname;
	
	  if (pathName === '/') {
	    return pathName;
	  }
	
	  if (pathNamePrefix && pathNamePrefix.trim() && pathName.startsWith(pathNamePrefix)) {
	    pathName = pathName.substring(pathNamePrefix.length, pathName.length);
	  }
	
	  if (pathName.substring(pathName.length - 1) === '/') {
	    pathName = pathName.substring(0, pathName.length - 1);
	  }
	
	  return pathName;
	};
	
	var Layout = function (_React$Component) {
	  _inherits(Layout, _React$Component);
	
	  function Layout() {
	    _classCallCheck(this, Layout);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  Layout.prototype.render = function render() {
	    var _props = this.props,
	        children = _props.children,
	        data = _props.data,
	        location = _props.location;
	
	    var pathName = getPathName(location, this.props.data.site.pathPrefix);
	
	    var activeData = (0, _navigation.findMatchingPage)(this.props.data.menu.pages, pathName);
	
	    if (activeData && activeData.file && !(0, _sideMenu.hasSideMenu)(activeData)) {
	      activeData.sidemenu = (0, _sideMenu2.default)(activeData, data);
	    }
	
	    return _react2.default.createElement(
	      _react.Fragment,
	      null,
	      _react2.default.createElement(_seo2.default, { siteMetadata: data.site.siteMetadata }),
	      _react2.default.createElement(_Header2.default, {
	        menuPages: data.menu.pages || [],
	        activeNavTitle: activeData && activeData.title,
	        githubUrl: data.site.siteMetadata.githubUrl
	      }),
	      (0, _sideMenu.hasSideMenu)(activeData) && _react2.default.createElement(_SideNav2.default, { activeNavData: activeData, location: pathName + location.hash }),
	      _react2.default.createElement(
	        'div',
	        { className: 'container' },
	        _react2.default.createElement(
	          _Main2.default,
	          null,
	          children
	        ),
	        _react2.default.createElement(_Footer2.default, null)
	      )
	    );
	  };
	
	  return Layout;
	}(_react2.default.Component);
	
	Layout.propTypes = {
	  children: _propTypes2.default.func,
	  location: _propTypes2.default.shape({
	    pathname: _propTypes2.default.string
	  }),
	  data: _propTypes2.default.shape({
	    site: _propTypes2.default.shape({
	      pathPrefix: _propTypes2.default.string,
	      siteMetadata: _propTypes2.default.shape({
	        description: _propTypes2.default.string,
	        image: _propTypes2.default.string,
	        url: _propTypes2.default.string,
	        type: _propTypes2.default.string,
	        title: _propTypes2.default.string,
	        siteName: _propTypes2.default.string,
	        githubUrl: _propTypes2.default.string
	      })
	    }),
	    menu: _propTypes2.default.shape({
	      pages: _menuProptypes2.default
	    }).isRequired
	  })
	};
	exports.default = Layout;
	
	// @TODO Figure out way to avoid globals
	// eslint-disable-next-line no-undef
	
	var query = exports.query = '** extracted graphql fragment **';

/***/ }),

/***/ 711:
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAk0AAADECAMAAAC1BOVTAAAC4lBMVEUAAAAaGhoaGhoaGhoaGhoaGhrwv07xqkkaGhry31XyzFEaGhoaGhoaGhoaGhoaGhoaGhoaGhoaGhoaGhoen84Vu9op1dF44qrxuEzx1FPvskr1wE/vvU31uE3yu03yu04dpNEaqdHurkkbqdXv1lPvxE8li8YWtdbv01IXtNnuuUz11lMYsNby11Puvk30r0sVutolisUenczyx0/yrksUvt7wwU71yFDxwU4ik8kRxN313FX14Vb0tEzyrkoOzeIPy+T10FL1xlDytEwjjcQfntAkkcoRxd9mlJ7xyE/uq0nIlz/Jlz913afNpFbXp0Ulhr5hmqIaGhr/zlT/y1P/vVD/0VT/xVL/1FX/wlH/01X/2Fb/v1D/uU//5Fn/x1L/4Vj/6Vr/3FeD8bAgpdkjnNWb95qB8bMll9MUyukS0Oweqtscst+Y9p0dr96K86qP9Kb/31f/5lmR9aT/1lWU9aAbt+ETzOsaueIR0+0Q1++W9p+H8q3/u08erN3/yVKF8q+T9aIhodeI86z/tE4kmtR/8LUfqNoXweX/7VsO2fAho9gbtOAjntcWw+YVxugZu+MQ1e4VxOcYveSe+Jj/61qg+JWM86iN9Kf/t07/2lYVyOgYv+UmldL/sE2j+ZL61FQO2/GDxXH6tE1+w3XJmkAlkc2AxHPJlz/6zFJ867D6w1D70FP66Fl5w3r3v098w3kO1uv9t07Ikz6F5p73z1L7x1F+77T7v0+S8JyC7KuK55n5sUwRzOb3yVGM76H441f63laH7aYbr9qf85H3uU4R0et846eA5aOQ6ZR9xHf52VX6rUsWveCW6Y6Y8pcYttwVw+B44qqc7Ir92FX0xlD7u070rUqQ9KLTpEMtychww4J0u3bhs16O3oUWzt8ul8VWmqzlukuH0n+BwG59uWnkq0d66K5Nw6YroMpUpLCaqIaYrYlOx6VPyaSIzneZo4WaoYR9yX1KwKJ7yH+anoTBpIj6AAAAUnRSTlMAwECA8BARhCDDw7DgUDDQcGCgkCIi8YQiInTxVPHDs8R0VPF0dIR0VPFE8cOzMvHDhHSzs/GE8dLDdPHx4cjD8fHhk3Tx8cPClDPwxIWRJWYxh0KP9wAAH1dJREFUeNrs3D9rU2EUx/E7FeyuKIouFktFEYp/UME/i3RWQqkQq1uyKUJJF2c7WCJtBzMYS6FcvEUzpNsNKZQMKSilzRKhDlVwUQffgCfNbX+NMfec58lzt/Pr0L6AD+fbQp94zWPS3WrvqGe0kSOGG/NcbmB00GCnxzxdP/vzNazVSuLVwlue2Y5Uq9UV6aq0Yc/hxsrlYq8Fh1b2y+VGo3HR0/Wz782wVJqZeXewmbhN50vhdc9oJ24SpvmXPTePPaatVG8OeM42Ui5ubz/s2PNo44c3kUoFfqVxxdP1p+nL1xIsda/LU+m2YevOVoGJN0WcLrjr3J3i9htAijWVCirXPF2fmr79qpUEkMCpZtw60sRbAid3rRstbjOWsMDXzjnQtNjsPk6xsasZt25FYAm1c9a64XIRgrjWBRXtnAtNaB0g9bREs2md3BKNWueoc2JLEylfO+dE0yK1bkYCKVrevnW8JRpa56ZzvCWads6VJmrdNO8IK4XmreMowRJa56pzvCXq3JCnc6OJWieBhONk3rp5/ixhz9A6B51jLREmf9DTOdJErcsLIDloHWPJYesG0TnO0kTKv3rc07nRRGvWpnlIWM6mdbwlrHqjz9YNdXYOlLosESbtnFtN1LppEST71q0wlpy27kRH53qeJe2c230jTVHrpoXL03Kheese85awNFpn2Tk+cdo519shTVHr8rwjrGbRunnWEvYMrbPrHGtJO+d+W7skqd064sRBwnI2reMtQVMarbPp3HOpJcI06ukcadr6HXH6FZYkkHCc7pm3TmyJll4btu5cMC61lKLODXg6R5rWtxbROhkk+9Y9llqi2bfuSrkotkSn6ZSnc6bp7c5/W5ePXY5m0zqppfZxsmvdxTJ1TmZJO+dc09v91v0McyJI0SxaV20dJxGlPlp3LRiXWdLOJaEJrQtzvCPMqnW8JWhC68w6J7Z039fOudZ0uHU5ASRosmidyBJaZ9O5caEl0qSdc6+JWre8t59hTQbJvnUCS9gkWmfQOdYSTtNd7Zx7TVvL0dA6BpJ166pyS+k0WmfQOd4SOjfi6VxrotZFmqLWMZCctI63RDNt3Qh1jhZnCZjuV/T9XBKaqHXLB63LCZdtzaJ1z6SWaIatG7gbTHRQirOknUtME1on4JTFpmxax1vC1kxaN1aeYM4SLGnnMKeaOlsX1nhImE3reEvYJFon7RyfuNZ87RzmWhPfuux/N2XXOt4SOA3LOye1RFvVziWiiW9dtvdq5q27QZx4S/LWoXMpoSWaPlLBnGqKbV2W25RF69JyS2gd37mAtQRM+hgTc6+JtovWySDZty4toAROG8PCv+cYS9gD/dABLBlN621MS0vNMGuy0KJ1Eks4TucFrRv1U5wlbFU7hznWhNYt7Y1aJ71LrS+L1q2lGUvGrTtVDjhLmK8froMloWmhtd2l9n6EU0JINPpWsGsdLHGa2NYNXA0mOEvo3Kp2DnOqaWGfEm09Ok7UuikJpP2fMpvmrUuLLdGodWznOEvApJ3DXGs6vJ0ltC4eEn5orXDZtnUCSrSnGxe4znGWgMlv6CMVLDFNna1jLlLHMrPGrSNOQks0pnXUOd4STtNpT5fIPv2jab2+37oCOAEPHHXMsnVSS2zrqHOsJWA6qY8xsUQ1oXWbB9cJ9wiSujRZtG5SZolv3VA5ACXG0oNV7RyWmKbu1oUECQcpdplM4ZVF63hLktaduOqn4s8SLD14oZ3DktTU3TrJMtEKDlsHQ9jTnq0b9AOZJZp2LplBU0zreEjYrJvWwZKwdUOVQGpJO8fMvSa0bjMjgYTjdMm4dZOcJb51x6lzQkvUufdnPB2WsCa0rl6vN2czEkjgdM60dWsSSzhOaF1H50SWos7pPzUxc6tpbmHuU709ap3AETS96rd1k7GYnj5B6w53TmyJOqePMZm51TRHW9iNOKF1Gclm+2tdPKXWult3seELLGnn2LnXNLe/z/VozdcZQBJwMm7deeIktETrbt01P2AtaecSHzQBEobWzYoY2bduY01uqbt1VyqB2NKL1Q/auaQGTUCEUes+tvZjsyCmRLNr3SRnCXtTHO7sHGcJe6SdS2rQ1KkIrfvYXvNVQQQp2muL1vGWsCd7rUPn7rOW8EuTPlJh5lwTWhdp+rL5usA6wqxaJ7SE1qFzvCV0Th9j/mXvXl5vCOM4jj8zc4aTcz9DyV2SS0jJZWOBlUvUKPdSFlYs5JKykJ2FEFZYnI3yi1A6IsVCFtIvFOWWBSVr/AHGzPA5M895nu93HjPS5LMijsvx+j3vMb9zIFaYpr0XPgWU0DotJOzMmXMGrTtAW4Kml7256NzmLRQldG6N+L/CBk1U616cYUGKZ9I6vqVgv1o3ZvUIeSwB0//OFTpoIlt3+hIJCTt30rR1tKVwF+PWrX3AtnR89//OFThoejY8dD+H1p2hIGEmrRv39ADHUry4dfMfjHAtHT9+53/niBWlae+vPbuF1tGQsNOjxq2jLcWtQ+dIS8H+d67YQZMECfvZuhvBgtadoRxh506btI62hF3sLUTnCEsRppv/36RS5KAJkuR9uhHty4tzPEjRTpu3Tk8JrVuGzlGWfl40/X8zZqGDpr0yJLTua8wpaB0NCTtp0LoD5LGEXXzaH2FaCi+aVog/mWclVnMFZxbWFP/+Gtbg2oK1rjWwRqhJtyexpnejp0lImFnrOJZwOPW5lnb/cecsPzlHcOZjtvj359b9wTUFY21/YC0BTap9iDl9e3GOAwmHU/bW7eFYAqcRpiWic3xNWLOEmkTDT9qgV60knhRoIlv3/i04aSGZt+4pxxIuxPsaS6D0E9MKkbMmq4yaRE1zANPPS1tAE9m69++WnjzHcnQ63MlRg9aRloDpYtA6ylK4rehcbpr8Thk1uYmjplLN1DlLQBPduvfv54yepiFhRq1jWwr2sj9CJC7GNEnkrqnillBTqnUWt3OwR2vaH7Qu1CQWvzhNQ8JMWreHZSnazl6fsBR1bprITRPmlVGTqGU5gGtS56BJw+lJrGnC0pOnWZCMW9e7yLAUL2wdZSk4miZPzFET1iyjplTrXPZBZgmOpv3hPkSaxJzRkxSkHFqnpYQF/zsmWqewhM7lrskqo6ZU62oUPLgjNe3/vWffI01i8QCn03pJPzf63KB1XEvB0LqUJWhC5/LRhLXLqCnVugbvO+L7PXmmhIQ9iTSFraMdYaPzMrfuJctSPLRuuCV0Ln9NFbeMmpKtq7usQ6wmoEktCfsQagpbR0PCTFp3kbaE9fp3NJbQufw0Yd0yahIdf3Aet3PQBEjK3fseagpbx4Rk3DqWJXBSWQoxTRf5a4KRMmpK/WZtXuegSScJrYs0Ba2TOJ3U7HLm1s1G63SW0LoHKks/Ozcm7yfY8rFWKTVVk62jO+eJhKb9jB37FGhC6wBJRynY+eyt66Vap6CE1iksBUfTFJG3pmriQryMmkTbH5xDda7uJjTtZ+3eDSHQOgakeCatoy1hh3p9yVK07ehcfppEN3EDuIyaUq1rEp2zhYmmDyLahHmjtCPsvEnraEvYtusPJEvh7k4dI/I/mxIfl7VSakq2rsXrHF/TsWPH9t97IuLNeT5KQgKm8+efL8jcupcsS2idRAmdy1mTLZzEB2YZNaVa19a9EKrl8jRB0k9MoSa0jgUpXvbWrXp6kbSE1G3r9SVL+Ptc7ppE3cfqpdQkLF/Tcy/ZQUoTIGHQhNZpIWFnjxq0jm0pWNS6rYltv7tyTDGakge9U0pNaJ38SSRb+u0TmiAJgya0Tg8JnExax7MULWjd1jSmx/NFQZqEpfjANdfU7DhWPM+xXcFds+HgldkOHpnRTvizN9Wt6yg7JyhNgCRrQuvOMyCBU/bW9XYyLUWHUz+t6eYaUZimquID10yT26lV/ORa7aqgh8dhdU/9UzmYPQDSi3nYmta5VOegiZQETWjd2fMkJGA6eyRz6/ovSUvAtG1H/4HUuYI0Sc9o4480VT2QGFwND+E9DqDaihOqNSRQtqX4NTYVLyaw9ffbntyjJEFTonVwpIMUzah1bEvB0Dp0riBN8t07c02u4ytX051Pjq9ZZThwS9Lk1nzM1v0MDXROdSxD0zFyh0NN2ILR8zQk7OjzmZlbR1CCpWDJ1t1F53LXJF9WOMaa7LoWRUco1mz5+tVcjia7orvZ0Rr2YgJPdckITccYmH5pQuuOkpAws9axLMXbMvK7ddvRufw1dYY81VVDTY5PrKvAVPGptVzt78KLXy0gaVK2ziM6x9V0ONq9+yIaWkdDwo6atY62hMPpWmwp6NwiYTq6EfLTaplp6vrkugaYwEnzuWsZk2/rsdtE56CJkARNidY9P0tDwo4YtI62hO24/iCyFGBaJorUJH+qqmOgCZj4nHAviF6X0NTwZU3a1qU75w7XRECSNKF1Z3mQjoZ7nr11PZYltG57OLwZsyBN8tt/3OyaPJ81T/FnTM/WaqpWaE3J1jnJrzcErQmS1JrQurO0I8yodaQlbEfQuuhoWlewJrkDXjZNcmcqtbZdDYza7ZqfXEP7OTQ/fFx4H9NLMatrNVmUPrl1iWv/miA0ARKlCa2jIWEmrTukuCUgWwp2/UGIaaz4G5pEPfFME5qIl6R1XHyT6+jehuRW1HcRbEtyqNJkk2eZfA6SpzE0QRKtCa07woAETadMW0dbCrdl5NX2XehcwZoa1IU4UR2s66aotdTnXkd7veYkqGk01ZPHmNV1HMDEJHSQqtJ0GJBYmrCZz48yIIFT9tZd38a1FB1O19C5IjXJItqUJtoE5naVNyBa0gPVnNS/i8rAF7sNYKau7iBcrQnjakLrjgISvVOPDFpHWsKCC/HHkwRWrKaqHCRaEyqJH5FITFcM/zkt6oG2+jxEYzP9o064l2mu6UQwaEq17igDEg6neeMzt462hF0fmSywAjXJB0E3g6aOokeKyyN3+CNt6vX/DqWp0hbU7Gxv1rl/j4AUD5qSrTvCcxTNqHUcS2jdFIEVqEm+Irb5mur0K1o6wyvqkS/Uq0hQlZpaTUHPIzpHaoIk7DU0pVtHQ8Iyt27jx9420hJSt2Vk+RghitSkvPxpsTXZROcgTvqRLfLPtKZMoUXcLue2riWyaQIk5dmE1j1nQML2ZWvdpvW3+z22pWCbR5YIUbAm4kKc1NSVKka8NrsKY+RfqxxCE3XxQ7eumUETJJFnE1pHQ8LhlKl1G65cedPfwbMUDa37C5qa0oU4R1OF8+5zN+GUHjRhWk22YM7jdg6aAImrCa07QkAyb92k21euXPl4nWMpHlpXtCb5me7yNNnSfRvqxW21AjR5gju3Qp9p0ARJOk0PoSndulNHaEjQtG/WeH7ngqPp9u0HPa4ltK5ITcSFOKXJkUJHsajnrgkHKb0G5yIcmk5QO3jwIDTJrXt0Co5ITKcytG7D1eBouv0GrSMsoXXFaaL+xWxak8W7oG0w0Jlr6mY+mjDbWNPBcNCkaB0LUrx93NZN+hgcTVHrdoCSwhK2Ga0rWBOChG+lNZEf5nIQ7dw1NQ3/fTC0jq8Jkjiaxs97zoCEPeK1btHNa5+vhLv96jrDEjg9WPL3NNmJflRpTVXm5bXrY528NdUNOod5Gk0UJGjStI4DCZxmCMZW/GDvXl5miuM4jp85x2hqzA0LuUc2FhaUbNjIBju3pshmrEYoW5dCzeL5A7CWMlFTaJoQRco/4PIsbCyUyx/hd84wb+Y7v/P9zslPkg9yv+R5Ped9jDlz7h67uzjmtNg/qloC06E+rQuqST7rrapqsh9zLI9KxXGS/HoXmGUmTcuLdI7FVk1I0jXROjgpkOyt2zlwT80dpJay1lmPS+loXTBN+om41CQPHo1SzhRNldZyKiumaGoV6Rxr+DW90yTpmlZuPm2BhCa9ddscJjfXumyv79kOS+PRurCaOBEnIXZN9iWCUoKkIpriIp1TeKMJSAU00Trd0ffprds1aB9LR+vslmhdcE3yRFzRRBltI6Cszq9RUFPBzrF6jqbz2s6hyds6HRJ7Qev8ncv2ctK6o1ZLtC68JnkiXlY0lQpoKolnP4XWJDu3pGFo3eNn784bhiZf617okBit83Vu1B5ratM63RI7TOtCauIvXZ7gLgujiWsqi2sqFehcs6K0zqzp3LlzaPK17rQJkql1S3d/x9R2m7TunsWSbF14TZWZJ+Kl36cpEc9bCKxJdq4hLjoopOnceM8eRpHSOgskNHVzWrd30M4sZRuMNd350D+qWmKHh7QukCaWiAiE0gSm8Jqq03hE68yagIQmrXWngaTuTE7rtg5GE0tuH1NLd+641lkswWnHH9BE1VgznKZYPC5dTWqxeDjLqsneuWTWBXZ2TThCk9o6HFk4bczpnLPEFu9kW+wfMluideE1yRNxo6ZSoftWsCUryE1BTfbOySen1C2akMTeocm/jS8UQFrr6NyvG93ONLnWWSxxcFqzNJwm/URc17Qkypt6tXni1IbSJF/GWT4Rs6FqOufZDTTlts6yM+kHN1o33bn21N46SrJ1uZTcLtO64JrkDZOlJvn+Hdknr5Lh0BBAk+dlnGOldWhCklWTbN0LC6TJuhs9nWOidWZLbv3Xa0No0k/ESzmakuKaEi8m1iyiyX67gqrnP7nRBKTCmmidDom96M1o3YaBsHT8OK07ZLXkRuvCapIn4i2hSb2IiZl+i5YizqjJ3jmUsZLUBJnimmidARLrytZtejmatuT2a+sO5Vtil+9uCKtJJob35pL+HIJm4dAtiwJp8t9+ju9hzRCaaF1XcpKIclq3dN1IWMr2cdI63RIb3l0bVJP8Ufy4xHMMsj8xxH7lJVtu1mS/zar9lekfPlMhpUOT1rozBkho6m2f7txxYSnbm8VJ64yWaF14TfIcueLV1BBHGOMSSyNLRk32ztXUV6bXNSEJTbbWnQGSsktnLqWtk53DEpu0rm+2ROvCa5JXkktN8uhRL6qpEnm2xKbJ3rmSchcWTROS2HU0qa07Y5SUfdajdXROWjpyZNK6p1ZLtC68JvloTOzT1NJTpx8x1ANkcU10jpbprUOTHxJDk9a6rsHRpcmXup3tsnPSkhut0y2xy7QuqCb5Pt30aCrbLkRKWKxFjDVtmsxqOfawunx+A5pu5Ehiz9Gkti5fEqSy0bpo9cuR15Lby9TSgwd3aB2W/DtJ64JqkifiUpN8ayWWuzW3ZCJj5U9g12TvHNBl69CkQbqeDk1q63ov1CPSJdbt/GjdqnWj4zMssY/Oktvi08O6JTYcrA2vic4wFgso6gnQMnk5XSKByT9AYU10Tv/jNUTr0KRJQpO1dVISXxKbtG79m+OzLLGLiw+yfegfNltyt2nlZtGBNLFE0SSlNPRfaDkV0y4mX27UpHRO/U9u0To0KZDQZG5dVxyQcCQ19TavpHMzLLEnGSZap1tKR+uCayov0zRBBSvKqUmdtyGraG9lXZPeuYbtlS5qiiYU2TWx7T1xdPKM1mWd81GidWNOi8PDUFIsudG6QJpYTdFETOCk3K6AN71yQsNPUzUZO1e3vdcsKaNJk4Qme+t6l4CULyldb2F72jmvJVI3aZ3jZLV08iStC6WJlfI10SxWqkyT9LxJq/kIwVRcU1U8dcDSuiqafJDY2bNn0WRs3SUbpO4l9yFtneucasnt1p0xp6d9syW3Ia0LramiaOI0li1Jyj+jqMrLtDl9978wdBNMhTXVDK83ADtWQ5MiyQ1N1tZ1ujZI4y+61r18o1rKNm7dwfXDywZLJ3+M1gXSxBJVE+dFrNqKPbckKMsHunnRehA3aY9dk37dspJEWoemfEhomqt1Xa8jNxyNP+9d+TrSLbmdOJG27sDSVWuGuiV2jNaF1sQphX5nDH1L6ByFZOnNfFtJUuX3LKRJT6lca1brHj7XJKFprtYJTjBKPyAq09T59N5iye2+07Qpira87hsSBydaF0YTq+ma7Jf8tkQhlcnHqeyaauJwYz9DrKHJC4mhqUDrukjyrLfw2WTJ7eODg5Hb+ruXTZZoXVhNrKRpsnNqGe9NhwHxEiw2TcQLHsoqonVoQpKiydy6TleeIvlFudbplrLdOpBFi9YplkTrQmuqKJrsnFpzF7IeFddUFemS83e3iiYkGTTZW2carVMtZaV7sjXKtuXuULeEJloXSBNL8jSxpvWcSecEP5um4p3zd7eWaQKSSZO9dQu9uTRd+ZxjCUy39kZutM5oyWmidWE1yRPxWLnbs36rZxYvyefX4OtNqyY6x0/Vxr9MAeg0YSlX06uIWVtnczSe4/R12hKU6Bx3gHatu2y15EbrAmliNZsmHiOSK8Veq75ELi+LP6xFE53TUqgchFdYNV01abK3Dkiss0Drpi1xZBp3jtaZLbkNNoTTVPCV3sutxkwYcZSzGE/ypyR8U9WoSXauMsdVNCzWNV1Nh6a5Wnelp0JitE4mjpOmrHO07qTd0rh1f9/qzdIvR6jGilpZPdFvVn95gmS1VY7+hqHJI6mAJlq30FMgMVqHJYFp0jlaZ7NE6/7KVeJWkq4Z1+f4Oc0kXS3+OySNNSmQCmiidfs6PQWSbB2WJKa3+6fuXzcY6pZY27Xu/8TCagIRe4SmAq3TIWVzrfNbuulOmrgDNK3D0mxKf3/r/p2hyS/pgvvAsWne1umO2MKprz5LN2/ef7In+jFad1c/LLH26G9t3b8xNAFpypL7ePYCmuZs3YIBErvy6b3H0s2sc2KrB8McS/9bF3xSE5KkJUfJfbpA6eZtXUeHxBaufJ5tic6J1h3zWPrfuj++V8+R5OPkhqa5WwcnIPl35dTXGZbonNI6LHlbt+5/69gf1XRhPEcKTfO3rgMkdQuudcKS27UndE60zm6p3f7fOrHgmpA0PjZx3lSwdR3raB2WHKZbb1dHTLTOaslt9HJT9H8soCYgMUpXuHWW0bovU5bonK91x6yW3P637lt7d8/iRBTFYXwq/QKCYmFhYWGzCDYW2igigqKFhRCrMCRfYmEZMjYhHyBFtgmkiIWQJiDTihapUiRVYFMFtdHC3pvV+PiSnXPm5t6gcP7sVlvuj/OkmQyLqAlJoTTROu3a7XbmWrexROcOLiWM0TrJEqtZ61hoTRIkNHm3Lm1rIG2WpR+xVNo5Wqe0ZK2LMzQhKbgmWteWIbEs/9T9XROdO6t1GkvWulhDkyzp6OgITX6tg1MJJI7Th8Wvlujc2a17JVtitZm1LsrevxEguaHJv3WZChKt62KJzlVuHZasdTGHJlESmvx3K2tLjrCUZZ1N61rrFTcTVtI6yRKrWetYbE1AQtO7hPm2Toa0WXqy2FhyneM/X6F1WLLWxR6ayiQxNHm3TobEOvnyh6VWMVdV6crr56IlMNWsdSy8JiSF1UTr0kyGxNL8k5NE5zSt01tym1nrWEhNQIqgidalmQiJdVzrlJ2jdWpLbtY6FlbTkbB6vY4m79blmQISmvKltnO0DkqSJWsdC6pJlFRHU5jWlTv6sbS5bt1E0Tm+hfW5aIk9s9btTROQ0BSgdZkEiaW5a92Eh1RUrdNY4jhZ66JrQlIoTbSuI0JimWtdMedhTF3rZEvWOhZXE5CCaqJ1HQ0kWveZhzGVrZMsWetiDE2SJDSFaF1HA4nWPU10420IkiW2fj3CzcQWcO/eCJDQFGD38lQJ6fuatxKma11NbcltZq0LrAlJ8TVdX+YdGRLLm/cSz9bJltysdaE11VUbhtB07vbiJNU4gtP9C7u1bisldmit27+mRpjbdLc/+tRMZUgs36l1tVJL1rok+Y9v0/Wi/6K7zFMZEst71VtX01iy1iXJ/6zp3O3+qNtdnMDpTzqdtPP3cfJonWjJWsf2rKmxXgBNN4tR1821TgOJ41S5dbOabInN+ta6/WhqbBbgNl0t+t3TLZs6SP6tm8mW2KG1Lr4mJIW5TecOXOfcTlsnQYKSm0/rzrRkrYsxNAmQuE1BOve9dbnsKM03a/q0TraEppG1LpamxvYNp4E659ZaNnMFJDgN/FsnW3LfF9U/sNYF19Q4e3U0+XauxVMoixM4lUDiOPm3TrZ0yslaF1ITkmLcJjrX+r7PvVwDieNUuXUbTjIlN2tdOE0NeeMdNV0u+lhab9nLRUhgavY8WvdMssReWOsCaRqiqWyrXTRdOihaWKJ1sqMf82qd2pLbyFoXRlMj/m26U4x+WqJ1MiTm0zq9JTdr3b40vXz5cowmr87BiNaJkJhf67SW3Kx1MTUhyQ1N3p1jtK6ngIQmj9bNtJasdVE1ASmApjtgYsfHXwZNBSQ4VW7dnbeHJZa2vBHIWrfrpkNBEpoCdA5L7mc5aAqQArROtGSti6UJSeE0PZwXf1s6Xv+61mFFo8mjdZIla10cTUASNfl3DkturnUCpwCtK7NkrYuhCUnhNZ3nNGFps+VALWk9n9YdypbQZK0LoAlIYTXROShhSdu6Hqveuv5MY4njZK3bUdMYM+E13Zn0fztLYKJ1IiQ0+bRObWn9ZiBr3T+sic6RuNPRup4CEpwqt+6g/0JryW1UWOt20rQajzWaVlOvzk2K7ZZo3aAnO0KTR+tGL7SW1sfJWrebpuFYsaGPpnO3nabiuHRfB4Ne6fjzwM2jdY7TDDZsxFgxn1vr/DedrlZDcavV1EPT3bnbRNhyUGk+rVOvcJjm1jr/PXp0UbVHjzw+NWn2+MFm17buxp97klTb1fMVdz2x+e0bzVuBpCgtZJkAAAAASUVORK5CYII="

/***/ }),

/***/ 675:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ })

});


// WEBPACK FOOTER //
// component---src-layouts-walkin-default-js-586b88239541fd3a2db0.js